import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import template from './StaticTable.html?raw';
import Edit from '../Edit/Edit';
import "../Edit/Edit";
import FloatingContainer from '../Floating/FloatingContainer';
import FloatingMenu from '../Floating/Menu';
import aspect from 'dojo/aspect';
import EntityStore from '../../Tools/EntityStore';
import Tooltip from '../Floating/Tooltip';
import { AccessibilityLabelsHelper, ColorHelpers, DateHelpers, DOMhelpers, EntityHelpers, FeatureHelpers, HtmlHelpers, StringHelpers, TranslationHelpers } from "../../../more/Helpers";
import Button from '../Button/Button';
import "../Button/Button";


//import DataItems = require("DataItems");


interface AdditionalSortingConfig {
    sortingAttributeNames: Array<string>;
    ascending: boolean;
}

interface Grouping { cell: HTMLElement, row: HTMLElement, label: string }
class StaticTable<T> extends compose(_LabelInputBase) {
    templateString: any = template;

    private quicksearchContainer: HTMLTableElement;
    private inputQuicksearchLabel: HTMLTableElement;
    private layoutSelectButton: MdsLax<InstanceType<typeof Button>>;
    private layoutSelectcontainer: HTMLElement;
    private tableRoot: HTMLTableElement;

    private hiddenContainer: HTMLElement;
    //private tableBody: HTMLElement;

    private tableHeads: Array<HTMLElement> = [];

    groupingEnabled: boolean = false;
    groupingProperty: string;
    groupingLabelProperty: string;
    private groupingValues: Array<any> = null;
    private groupingLabels: Array<string> = null;
    sortDirection: "ASC" | "DESC" | "NONE";
    private rowSortingAttr: string;
    private rowSortingCallback: (rowGroupTarget: StaticTable.StaticTableRowGroup<any>, rowGroupSource: StaticTable.StaticTableRowGroup<any>) => any;
    private additionalSortingConfig: AdditionalSortingConfig = null;
    showIndexColumn: boolean = false;
    private indexOffset: number = 0;
    private indexCount: number = null;

    //rows_per_entity: number = 1;
    keyAttribute: string = "ID";
    labelProperty: string = "$Displayname";

    stickyHeader: boolean = false;
    headerBgColor: string;
    headerTxtColor: string;

    private customSortFunction: Function;

    private actionRegistry: Record<StaticTable.ActionType | string, StaticTable._ActionRegistryEntry>;

    private expanderRegistry: Record<string, {
        expandclickCallback: StaticTable.expanderclickCallback,
        isSetup: boolean,
        rowNode: HTMLElement,
        cellNode: HTMLElement,
        containerNode: HTMLElement,
        currentExpandState: boolean,
        rowGroup: StaticTable.StaticTableRowGroup<T>
    }> = null;

    private data: Array<T> = [];
    private store: MdsLax<InstanceType<typeof EntityStore<T>>> = null;
    private quicksearchProperties: Array<string> = [];
    private quicksearchEnabled: boolean = false;
    private inputQuicksearch: MdsLax<InstanceType<typeof Edit>>;

    private maxColspan: number = 0;
    private _createSimpleCellValue(cell: StaticTable.StaticTableCell<T>) {
        let value = cell.value;

        if (typeof value == "string") {
            try {
                //REGEX - String testen auf Datumsformat!
                let modDate = new Date(value); // manche Broswer erkennen "XYZ 2" als Datum!
                if (isNaN(modDate.valueOf())) {

                    // testen ob string html-Tags enthält
                    let elements = StringHelpers.stringToElements(value);
                    if (elements?.length) {
                        if (elements.length > 1) {
                            let wrapper = this.UiModder.domConstruct.create("div", {
                                className: "cellContentWrapper"
                            });
                            elements.forEach(entry => wrapper.appendChild(entry));
                            cell.displayValue = wrapper;
                        } else {
                            cell.displayValue = elements[0];
                        }
                    } else {

                        cell.displayValue = value;
                    }
                } else {
                    // daher unbedingt mit RegEx gegenprüfen
                    // es gibt mit Bordmitteln keine 100% sichere Methode, nur zunehmend komplizierte RegEx oder Bibliotheken wie moment.js
                    // für uns sollts mit ein paar RegEx inzwischen reichen...
                    let dateTimeHHmmss = this.dateTimeToString(modDate, "dd.MM.yyyy HH:mm:ss");
                    let dateTimeHHmm = this.dateTimeToString(modDate, "dd.MM.yyyy HH:mm");
                    let dateTxt = this.dateTimeToString(modDate, "dd.MM.yyyy");

                    let results = DateHelpers.GetDatesInStr(value);
                    for (let result of results) {
                        switch (result.formatType) {
                            case "ms":
                            case "msTZ":
                            case "sec":
                            case "secTZ":
                                value = value.replace(result.regex, dateTimeHHmm);// ss);
                                break;

                            case "min":
                            case "minTZ": // hihi, Minz
                                value = value.replace(result.regex, dateTimeHHmm);
                                break;

                            case "date":
                            default:
                                value = value.replace(result.regex, dateTxt);
                        }
                    }



                    cell.displayValue = value;
                }
            } catch (ex) {
                cell.displayValue = value;
            }

        } else if (typeof (value) == "boolean") {
            let icon: HTMLElement = null;
            if (value === true) {
                icon = HtmlHelpers.createFontawesomeIcon("fas fa-check-square");
            } else if (value === false) {
                icon = HtmlHelpers.createFontawesomeIcon("far fa-square");
            } else {
                // ??? kann ja nicht sein. naja, außer es ist NULL
                icon = HtmlHelpers.createFontawesomeIcon("far fa-square");
            }
            cell.displayValue = icon;
            return;
        }
        // DATUM kann auch komplett als Objekt serialisiert auftauchen!
        else if (typeof (value) == "object" && !!value && value.getTime && value.getFullYear) {
            let dateVal = value as Date;
            try {
                let dateTimeHHmm = DateHelpers.dateTimeToString(dateVal);// this.dateTimeToString(dateVal, "dd.MM.yyyy HH:mm");
                cell.displayValue = dateTimeHHmm;
            } catch (ex) {
                console.warn("could not date format table column: " + cell.name + "\r\n" + ex, cell);
            }
        } else if (typeof (value) == "number") {
            value = value.toString();
            cell.displayValue = value;
        } else if (value == undefined) {
            cell.displayValue = "";
        } else {
            try {
                cell.displayValue = value.toString();
            } catch (ex) {
                console.warn("could not format table column: " + cell.name + "\r\n" + ex, cell);
            }
        }

        let cellformatter = cell.formatterConfig;
        if (cellformatter) {
            // TODO

        }
    }



    private _defaultTableRowFormatter(cell: StaticTable.StaticTableCell<T>) {
        if (cell.displayValue == undefined) this._createSimpleCellValue(cell);
        if (cell.displayValue != undefined && cell.contentnode.innerHTML != cell.displayValue) cell.contentnode.append(cell.displayValue);
        //if (cell.displayValue != undefined && cell.contentnode.innerHTML != cell.displayValue) this.UiModder.domAttr.set(cell.contentnode, "innerHTML", cell.displayValue);
        //this.UiModder.domAttr.set(cell.contentnode, "innerHTML", cell.displayValue);
    }

    private customCellFormatter: StaticTable.formatterCallback = null;

    //function(cell: StaticTable.StaticTableCell<any>) {
    //    // falls kein custom formatter gesetzt ist, wird hier einfach false zurückgegeben.
    //    // die statictable weiß dann, dass sie die Zelle mit dem Standard formatieren muss
    //    // custom formatters sollten für Zellen, die sie selber formatiert haben, true zurückgeben, dann wird default übersprungen.
    //    return false;
    //}

    private headingLabelFormatter: Function = function (headingLabel: string, colname: string) {
        return headingLabel;
    };

    //currentlyDisplayedEntities: Array<object> = [];

    private rowConfigs: Array<StaticTable.RowConfig> = [];
    private selectedLayout: StaticTable.Layout = null;
    private rowRegistry: Array<StaticTable.StaticTableRowGroup<any>> = [];

    private availableLayouts: Array<StaticTable.Layout> = [];

    //headers: Array<string>  = [];
    //attributenames: Array<string> = [];
    //colspans: Array<number> = [];
    //colNamesInternal: Array<string> = [];

    customRowClasses: Array<string> = [];

    private multiRowEntities: boolean = false;

    rowsLimit: number;
    clipContentOverflow: boolean = true;
    tableLayout: string = "fixed";

    updateTable() {
        this.drawTable();
    }

    getData() {
        return this.data;
    }

    setCustomSortFunction(sortFunction: Function): void {
        this.customSortFunction = sortFunction;
    }

    private customSortData(): void {
        if (!this.customSortFunction) {
            console.error("Custom sort function not set");
            return;
        }

        this.data.sort((a, b) => this.customSortFunction(a, b));
        this.drawTable();
    }

    private sortData(): void {
        let compareFuction: any;
        let self: any = this;
        let propertyName: string = this.groupingEnabled ? this.groupingProperty : this.rowSortingAttr;
        if (this.sortDirection == "NONE") return;

        if (!this.data || !this.data.length) return;

        // wenn es einen Gruppierungsparam gibt
        if (propertyName) {
            let attrValue: string;

            //eine beliebige Value finden, um den Type zu kennen
            for (let i = 0; i < this.data.length; i++) {
                attrValue = this.PitHelper.getEntityAttributeValue(this.data[i] as any, propertyName, "json");
                if (attrValue) { break; }

            }

            if (!isNaN(Number(attrValue))) {
                // wenn es eine Zahl ist
                if (this.sortDirection == "DESC") {

                    compareFuction = function (a, b) {
                        let result: any = self.PitHelper.getEntityAttributeValue(b, propertyName, "json") -
                            self.PitHelper.getEntityAttributeValue(a, propertyName, "json");
                        return result;
                    }

                } else {

                    compareFuction = function (a, b) {
                        let result: any = self.PitHelper.getEntityAttributeValue(a, propertyName, "json") -
                            self.PitHelper.getEntityAttributeValue(b, propertyName, "json");
                        return result;
                    }

                }

            } else {

                //wenn es ein String ist

                if (this.sortDirection == "DESC") {
                    compareFuction = function (a, b) {

                        let fa = self.PitHelper.getEntityAttributeValue(a, propertyName, "json").toLowerCase();
                        let fb = self.PitHelper.getEntityAttributeValue(b, propertyName, "json").toLowerCase();
                        if (fa < fb) {
                            return 1;
                        }
                        if (fa > fb) {
                            return -1;
                        }
                        return 0;
                    }
                } else {
                    compareFuction = function (a, b) {
                        //console.log(a, b)
                        let fa = self.PitHelper.getEntityAttributeValue(a, propertyName, "json").toLowerCase();
                        let fb = self.PitHelper.getEntityAttributeValue(b, propertyName, "json").toLowerCase();
                        if (fa < fb) {
                            return -1;
                        }
                        if (fa > fb) {
                            return 1;
                        }
                        return 0;
                    }
                }
            }

            this.data.sort(compareFuction);

        } else {

        }
    }

    private createTableHead(): HTMLElement {
        // TH kreieren ---start
        let tableHeads = this.tableHeads;// HTMLCollectionOf < Element > = document.getElementsByTagName("thead");
        for (let y = 0; y < tableHeads.length; y++) {
            let element = tableHeads[y];
            this.UiModder.domConstruct.destroy(element);
        }

        let actions = [];
        for (let key in this.actionRegistry) {
            let entry = this.actionRegistry[key];
            if (entry.use === true) actions.push(entry);
        }


        this.tableHeads = [];

        let tableHead: HTMLElement = this.UiModder.domConstruct.create("thead", { class: "staticTable_thead" }, this.tableRoot);

        let topDistance: number = tableHead.offsetHeight;

        let colSpanCount = 0;
        let rowCount = 0;


        let firstRow = null;
        let visibleIndex: Record<number, Array<HTMLElement>> = {};

        if (this.rowConfigs) {

            for (let rowConfig of this.rowConfigs) {

                if (rowConfig.headings) {

                    visibleIndex[rowCount] = [];

                    let headerRow: HTMLElement = this.UiModder.domConstruct.create("tr", {
                        className: "staticTable_thead"
                    }, tableHead);

                    if (rowCount == 0) firstRow = headerRow;

                    colSpanCount = 0;
                    let emptyCount = 0;


                    for (let colIndex = 0; colIndex < rowConfig.colNamesInternal.length; colIndex++) {
                        let colName = rowConfig.colNamesInternal[colIndex];
                        let heading = rowConfig.headings[colIndex];
                        let colspan = rowConfig.colspans[colIndex];

                        if (!colspan) colspan = 1;


                        let th = this.UiModder.domConstruct.create("th", {
                            "innerHTML": "",
                            "colspan": colspan.toString(),
                            "data-colname": colName
                        }, headerRow) as HTMLTableHeaderCellElement;

                        let formattedHeading = this.headingLabelFormatter(heading, colName, th);


                        if (formattedHeading === false) {
                            if (this.canTranslate(heading)) heading = this.translate(heading);
                            this.UiModder.domAttr.set(th, "innerHTML", heading);

                        }
                        else if (formattedHeading instanceof HTMLElement) {
                            this.UiModder.domConstruct.place(formattedHeading, th);
                        }
                        else if (typeof formattedHeading == "string") {
                            // versuchen zu übersetzen
                            if (this.translations && this.canTranslate(formattedHeading)) formattedHeading = this.translate(formattedHeading);

                            this.UiModder.domAttr.set(th, "innerHTML", formattedHeading);
                            rowConfig.headings[colIndex] = heading;
                        } else if (!formattedHeading && !heading) {
                            emptyCount++;
                        }

                        // Breiten in der ersten Reihe setzen:
                        if (rowCount == 0) {
                            if (rowConfig.widths && rowConfig.widths[colIndex]) {
                                this.UiModder.domStyle.set(th, "width", rowConfig.widths[colIndex]);
                            }
                        }

                        //if (th.clientWidth > 0) { // funzt nicht, wenn Table noch nicht im DOM platziert!
                        if (!th.hidden) {
                            visibleIndex[rowCount].push(th);
                        }

                        colSpanCount = colSpanCount + colspan;

                        if (this.stickyHeader === true) {
                            this.UiModder.domClass.add(th, "sticky");
                            this.UiModder.domStyle.set(th, "top", topDistance + "px");
                        }

                        let bgColorValue = "";

                        if (rowConfig.headingColorsBG && rowConfig.headingColorsBG[colIndex]) {
                            this.UiModder.domStyle.set(th, "background-color", rowConfig.headingColorsBG[colIndex]);
                            bgColorValue = rowConfig.headingColorsBG[colIndex];
                        }
                        else if (this.headerBgColor) {
                            this.UiModder.domStyle.set(th, "background-color", this.headerBgColor);
                            bgColorValue = this.headerBgColor;
                        }

                        if (rowConfig.headingColorsTXT && rowConfig.headingColorsTXT[colIndex]) {
                            this.UiModder.domStyle.set(th, "color", rowConfig.headingColorsTXT[colIndex]);
                        }
                        else if (this.headerTxtColor) {
                            this.UiModder.domStyle.set(th, "color", this.headerTxtColor);
                        }
                        else if (bgColorValue) {
                            if (!this.isDarkColor(bgColorValue)) {
                                this.UiModder.domStyle.set(th, "color", "var(--dark)");
                            }
                        }

                        if (rowConfig.alignmentsHeading && rowConfig.alignmentsHeading[colIndex]) {
                            this.UiModder.domStyle.set(th, "textAlign", rowConfig.alignmentsHeading[colIndex]);
                        }

                        var lastHeadingTh = th;
                    }
                    // ganz am Ende, nach der letzten Spalte: Actions einfügen falls gesetzt
                    if (actions.length) {
                        // Eine Spalte für Aktionen anlegen
                        if (rowCount == 0) {
                            let actionsHead = this.UiModder.domConstruct.create("th", {
                                "innerHTML": "",
                                "colspan": 1,
                                "className": "actionsColumn",
                                "rowspan": 1,
                                "data-colname": "#actions#"
                            }, firstRow, "last");

                            //domStyle.set(sortingHead, "width", "min-content");
                            this.UiModder.domStyle.set(actionsHead, "textAlign", "right");

                            this.tableRoot.style.setProperty("--actionColumnWidth", (actions.length * 4 + 3).toString() + "ch");

                        } else {
                            if (lastHeadingTh) {
                                let colspan = lastHeadingTh.colSpan;
                                colspan ? colspan++ : colspan = 2;

                                lastHeadingTh.colSpan = colspan;
                            }
                        }

                        colSpanCount++;

                    } else {
                        if (emptyCount == rowConfig.colNamesInternal.length) {
                            this.hideNode(headerRow);
                        }
                    }

                    rowCount++;
                }
            }

            if (colSpanCount > this.maxColspan) this.maxColspan = colSpanCount;
        }
        else {
            alert("output table has no layout configuration set!");
        }

        if (this.showIndexColumn != false && firstRow) {

            let length = this.data.length;
            if (typeof (this.indexCount) == "number") length = this.indexCount;




            let countStr = length.toString();

            let indexHead = this.UiModder.domConstruct.create("th", {
                "innerHTML": countStr,
                "colspan": 1,
                "className": "indexColumn",
                "rowspan": rowCount,
                "data-colname": "#"
            }, firstRow, "first");

            visibleIndex[0].unshift(indexHead);

            // Anzahl der Stellen + 3ch ergibt die Breite. Also bei 23 Entities 5h, bei 655 Entities 6ch...
            this.tableRoot.style.setProperty("--indexColWidth", (countStr.length + 3).toString() + "ch");
        }

        // jede Reihe ergänzen um first-visible und last-visible-Klassen für jede Spalte
        for (let rowIndex in visibleIndex) {
            let colArray = visibleIndex[rowIndex];
            let firstCol: HTMLElement = null;
            let lastCol: HTMLElement = null;
            if (colArray.length) firstCol = colArray.shift();
            if (colArray.length) lastCol = colArray.pop();
            else lastCol = firstCol;

            if (firstCol) this.UiModder.domClass.add(firstCol, "firstVisible");
            if (lastCol) this.UiModder.domClass.add(lastCol, "lastVisible");
        }

        // Expander-Spalte einfügen
        this.UiModder.domConstruct.create("th", {
            "innerHTML": "exp",
            "colspan": 1,
            "className": "expanderColumn",
            "rowspan": rowCount,
            "data-colname": ">"
        }, firstRow, "first");

        return tableHead;
    }

    getSelectedEntities(): Array<T> {
        let array = [];

        for (let rowgroup of this.rowRegistry) {
            if (rowgroup.selected === true) {
                array.push(rowgroup.entity);
            }
        }

        return array;
    }

    private _getColorValueFromPath(entity: T, pathOrValue: string, target: "BG" | "TXT" = "BG"): string {
        let color = pathOrValue;
        // wenn die Farbe nicht mit # (also Hex) anfängt, dann gehen wir davon aus es ist ein Propertypfad
        if (color[0] != "#") {
            // property-Pfad?
            let propertyParts = color.split(".");
            let value = EntityHelpers.getComplexProperty(entity, pathOrValue);

            if (value && value["TextColor"]) {
                let colorobj: more.EntityAPIColor = <more.EntityAPIColor>value;

                value = null;
                if (target == "TXT" && !colorobj.TextColor.IsNull) {
                    value = colorobj.TextColor.Hex;
                } else if (target == "BG" && !colorobj.BackColor.IsNull) {
                    value = colorobj.BackColor.Hex;
                }

            } else if (value && typeof (value) == "string") {
                value = ColorHelpers.getHexColorFromString(value, target);
            }

            return value;
        } else {
            return color;
        }
    }

    private _handleCellColor(cell: StaticTable.StaticTableCell<T>) {
        let txtAlternateColor = null;
        let bgColor: string = null;
        if (cell.bgColor) {
            bgColor = cell.bgColor;
            if (bgColor) {
                cell.tableCellNode.style.setProperty("--colBG", bgColor);

                try {
                    if (this.isDarkColor(bgColor)) {
                        txtAlternateColor = "var(--bright)";
                    } else {
                        txtAlternateColor = "var(--dark)";
                    }
                } catch (ex) {
                    txtAlternateColor = "unset";
                }
            } else {

            }
        }

        let txtColor = null;
        if (cell.txtColor) {
            txtColor = cell.txtColor;

        } if (txtColor) {
            cell.tableCellNode.style.setProperty("--colTXT", txtColor);
        } else {
            // invertierte Farbe von oben nehmen:
            if (bgColor) {
                cell.tableCellNode.style.setProperty("--colTXT", txtAlternateColor);
            }
        }
    }

    private _saveExpanderNodesToHidden() {
        try {
            for (let value in this.expanderRegistry) {
                let reg = this.expanderRegistry[value];

                if (reg.rowNode) {
                    this.UiModder.domConstruct.place(reg.rowNode, this.hiddenContainer);
                }
            }
        } catch (ex) {

        }
    }


    getGroupingNodes(targetGroupValue?: string): Array<Grouping> {
        if (targetGroupValue) {
            return [this._groupings[targetGroupValue]];
        }

        let result = [];

        for (let key in this._groupings) {
            result[key] = this._groupings[key];
        };

        return result;
    }
    private _groupings: Record<string, Grouping>;

    private drawTable(): void {
        this.emit("beforeTableDrawn");

        if (this._rowContextMenu) {
            this._rowContextMenu.close();
            this._rowContextMenu = null;
        }

        this.disableNode(this.tableRoot);

        this._saveExpanderNodesToHidden(); // NODES retten, bevor alles zerstört wird!

        let currentSelectedEntites = this.getSelectedEntities();
        this.rowRegistry = []; // welche ntites welchen rowindex haben, e.g. alle entity-rows

        let headers: Array<string> = [];
        let colnames: Array<string> = [];
        let colspans: Array<number> = [];
        let propertynames: Array<string> = [];
        this._groupings = {};
        let cellFormatterConfigs: Array<StaticTable.CellFormatterConfig> = [];


        if (!this.selectedLayout) {
            alert(this.id + " has no layout set");
            return;
        }

        //this.UiModder.domStyle.set(this.tableRoot, "table-layout", this.tableLayout);
        this.UiModder.domClass.toggle(this.tableRoot, "fixedLayout", this.tableLayout == "fixed");

        //if (this.stickyHeader === false) {
        //    this.UiModder.domStyle.set(this.tableRoot, "overflow", this.clipContentOverflow ? "hidden" : ""); // mit Hidden werden aber auch dropdowns (Multiselect) in den Tablecells abgeschnitten. hmmmm.
        //}


        let tableHead = this.createTableHead();
        let tableBody = this.UiModder.domConstruct.create("tbody", {});

        let helperFn_ElementToRow = (clickedRow:HTMLTableRowElement)=>{
            let groupIndex: number = parseInt(clickedRow.getAttribute("data-tr_index"));
            let lineIndex: number = parseInt(clickedRow.getAttribute("data-row-line-index"));
            let group = this.rowRegistry.find((val) => {
                return val.rowIndex == groupIndex
            });
            if (typeof group == 'undefined'){
                return null;
            }
            let row = group.rows.find((val) => {
                return val.lineIndex == lineIndex;
            });
            return {row:row, group:group};
        }

        tableBody.addEventListener('click', lang.hitch(this, (ev:MouseEvent)=>{
            //wir machen event auf ganzen table body damit wir nicht auf jeder row ein click event setzen muessen
            const eventRow = (ev.target as HTMLElement).closest('tr');
            if (!eventRow){
                return; //kein click auf row
            }
            let found = helperFn_ElementToRow(eventRow);
            if (found != null){
                this._onClick_TableRow(found.row, found.group, ev);
            }
        }));

        tableBody.addEventListener('mouseover', lang.hitch(this, (ev:MouseEvent)=>{
            const eventRow = (ev.target as HTMLElement).closest('tr');
            if (!eventRow) {
                return; //kein click auf row
            }
            let found = helperFn_ElementToRow(eventRow);
            if (found != null){
                this._onMouseEnter_TableRow(found.row, found.group, ev);
            }
        }));
        tableBody.addEventListener('mouseout', lang.hitch(this, (ev: MouseEvent)=>{
            const eventRow = (ev.target as HTMLElement).closest('tr');
            if (!eventRow) {
                return; //kein click auf row
            }
            let found = helperFn_ElementToRow(eventRow);
            if (found != null) {
                this._onMouseLeave_TableRow(found.row, found.group, ev);
            }
        }));

        this.UiModder.domConstruct.empty(this.tableRoot);

        if (tableHead) {
            this.UiModder.domConstruct.place(tableHead, this.tableRoot);
        }
        this.UiModder.domConstruct.place(tableBody, this.tableRoot);


        try {
            if (this.selectedLayout) {
                this.UiModder.domAttr.set(this.tableRoot, "data-table-layout-name", this.selectedLayout.name);
            }

            // Data rows ----------------------start

            //  die anzahl der angezeigten entites begrenzen
            let entitiesCount: number = this.data?.length;
            if (this.rowsLimit) {
                entitiesCount = this.rowsLimit;
            }

            let previousGroupingValue: string = null;

            let tmpNode = this.UiModder.domConstruct.create("div"); // eine Hilfsnode, die nirgends sichtbar ist
            // brauchen wir weiter unten, falls im innerhtml html mit dabei ist und wir aber nur den innertext wollen.


            // durch das data array loopen bis zum limit
            for (let entityIndex = 0; entityIndex < entitiesCount; entityIndex++) {

                let tableRowEntity = this.data[entityIndex];
                //this.currentlyDisplayedEntities.push(tableRowEntity);

                let rowGroup: StaticTable.StaticTableRowGroup<any> = {
                    entity: tableRowEntity,
                    keyValue: tableRowEntity[this.keyAttribute],
                    rowIndex: entityIndex,
                    rows: [],
                    customClasses: [],
                    actions: {},
                    expanderRow: null,
                    maxColspan: -1
                };

                if (this.selectedLayout && this.selectedLayout.labelProperty) {
                    let displayname = tableRowEntity[this.selectedLayout.labelProperty];
                    if (displayname) {
                        rowGroup.displayname = displayname;
                    }
                }

                this.rowRegistry.push(rowGroup);


                let currentRowCount = 0;
                let currentGroupingValue = "";
                let currentGroupingLabel: string = null;



                // die entities sichtbar separieren
                let top_row_border_style: string = "";

                let visibleIndex: Record<number, Array<HTMLElement>> = {};

                if (this.rowConfigs) {

                    if (this.showIndexColumn === true) {
                        var indexCol = this.UiModder.domConstruct.create("td", {
                            "data-label": "#",
                            "data-colname": "#",
                            "className": "indexColumn firstCol",
                            "data-colindex": "0",
                            "innerHTML": (entityIndex + this.indexOffset + 1).toString(),
                            "colspan": "1"
                        });
                    }

                    // expander-Col fix erstellen. ist default ausgeblendet
                    let expanderCol = this.UiModder.domConstruct.create("td", {
                        "data-label": ">",
                        "data-colname": ">",
                        "className": "expanderColumn",
                        //"innerHTML": "exp",
                        "colspan": "1"
                    });
                    let expanderBtnContainer = this.UiModder.domConstruct.create("div", {
                        className: "container"
                    }, expanderCol);
                    let expanderBtn = this.UiModder.domConstruct.create("button", {
                        className: "expanderButton hoverDark"
                    }, expanderBtnContainer);
                    on(expanderBtn, "click", lang.hitch(this, this._onClickExpandRowGroup, rowGroup));

                    HtmlHelpers.createFontawesomeIcon("fas fa-angle-down expanderIcon", null, expanderBtn);


                    for (let config of this.rowConfigs) {
                        headers = config.headings;
                        propertynames = config.attributes;
                        colnames = config.colNamesInternal;
                        colspans = config.colspans;
                        cellFormatterConfigs = config.cellFormatterConfigs;

                        visibleIndex[currentRowCount] = [];

                        top_row_border_style = "";

                        // GroupingsÜberschriften rendern
                        if (this.groupingEnabled && this.groupingProperty) {
                            currentGroupingValue = this.PitHelper.getEntityAttributeValue(tableRowEntity as any, this.groupingProperty, "json");
                            if (this.groupingLabelProperty) currentGroupingLabel = this.PitHelper.getEntityAttributeValue(tableRowEntity as any, this.groupingLabelProperty, "json");
                            else currentGroupingLabel = currentGroupingValue;

                            // prüfen ob in grouplabels und groupvalues was passendes gemappt ist!
                            if (this.groupingValues?.length && this.groupingLabels?.length) {
                                for (let i = 0; i < this.groupingValues.length, i < this.groupingLabels.length; i++) {
                                    if (currentGroupingValue == this.groupingValues[i]) {
                                        currentGroupingLabel = this.groupingLabels[i];
                                        currentGroupingLabel = TranslationHelpers.tryTranslate(currentGroupingLabel);
                                        break;
                                    }
                                }
                            }

                            if (previousGroupingValue != currentGroupingValue) {
                                let groupHeader: HTMLElement = this.UiModder.domConstruct.create("tr", { "class": "table_groupHeader topRow" }, tableBody);
                                let node = this.UiModder.domConstruct.create("td", {
                                    "colspan": config.headings.length, //LH set this.maxColSpan ???
                                    "data-groupingattribute": this.groupingProperty,
                                    "innerHTML": currentGroupingLabel
                                }, groupHeader);

                                this._groupings[currentGroupingValue] = {
                                    cell: node,
                                    row: groupHeader,
                                    label: currentGroupingLabel
                                };

                                previousGroupingValue = currentGroupingValue;
                            }
                        }

                        if (entityIndex == 0 && currentRowCount == 0 && !this.groupingEnabled) {
                            top_row_border_style = "topRow";
                        }

                        let row = <HTMLTableRowElement>this.UiModder.domConstruct.create("tr", {
                            "data-tr_index": entityIndex,
                            "className": top_row_border_style
                        }, tableBody); //data objct

                        if (currentRowCount == 0) this.UiModder.domClass.add(row, "rowGroupStart");
                        if (currentRowCount + 1 == this.rowConfigs.length) this.UiModder.domClass.add(row, "rowGroupEnd");

                        switch (config.colorationStyle) {

                            case "bottom":
                            case "left":
                            case "right":
                            case "top":
                            case "top-left":
                            case "top-right":
                            case "bottom-left":
                            case "bottom-right":
                            case "inset":
                                this.UiModder.domClass.add(row, "bordered");
                                this.UiModder.domClass.add(row, config.colorationStyle);
                                break;
                            default:
                                this.UiModder.domClass.remove(row, "bordered");
                                break;

                        }


                        // wenn die ganze Reihe eine grundsätzliche Färbung bekommen hat:
                        let rowColor = null;
                        if (config.mainColorationValue) {

                            rowColor = this._getColorValueFromPath(tableRowEntity, config.mainColorationValue);
                            if (rowColor) {

                            } else {
                                rowColor = "var(--mediumTransparent)";
                            }

                            row.style.setProperty("--rowColor", rowColor); // kann pro Zelle noch übersteuert werden
                            //    row.style.setProperty("--colBG", color); // kann pro Zelle noch übersteuert werden
                        }



                        let rowLine: StaticTable.StaticTableRow<any> = {
                            cells: [],
                            lineIndex: currentRowCount,
                            node: row,
                            clickFct: null,
                            entity: tableRowEntity,
                            rowGroup: rowGroup,
                        };
                        rowGroup.rows.push(rowLine);

                        row.dataset.rowLineIndex = rowLine.lineIndex as any;

                        for (let colIndex = 0; colIndex < colnames.length; colIndex++) { // x: entity , i: row-per-etity , j: <td>

                            let outputValue: any;
                            let td_colspan: number = 1;


                            if (colIndex == 0 && currentRowCount == 0 && this.showIndexColumn === true) {
                                this.UiModder.domConstruct.place(indexCol, row, "first");
                                visibleIndex[0].unshift(indexCol);
                            }

                            if (colIndex == 0 && currentRowCount == 0) {
                                this.UiModder.domConstruct.place(expanderCol, row, "first");
                            }



                            //if (this.multiRowEntities === true) {
                            td_colspan = colspans[colIndex];
                            //}

                            let cellFormatter: StaticTable.CellFormatterConfig
                            if (config.cellFormatterConfigs?.length > colIndex) cellFormatter = config.cellFormatterConfigs[colIndex];


                            if (propertynames && propertynames[colIndex]) {
                                //outputValue = this.PitHelper.getEntityAttributeValue(tableRowEntity, propertynames[colIndex], "json");
                                outputValue = EntityHelpers.getComplexProperty(tableRowEntity, propertynames[colIndex]);
                            } else {
                                outputValue = "";
                            }

                            let safeHeader = "";
                            if (headers && headers[colIndex]) {
                                this.UiModder.domAttr.set(tmpNode, "innerHTML", TranslationHelpers.tryTranslate(headers[colIndex]));

                                safeHeader = tmpNode.innerText;
                                if (safeHeader) {
                                    safeHeader = safeHeader.trim();
                                }
                            }

                            let td_node: HTMLTableCellElement = <HTMLTableCellElement>this.UiModder.domConstruct.create("td", {
                                "data-label": safeHeader,
                                "data-colname": colnames[colIndex] ? colnames[colIndex] : propertynames[colIndex],
                                "innerHTML": null,
                                "colspan": td_colspan.toString(),
                                "data-colindex": this.showIndexColumn ? (colIndex + 1).toString() : colIndex.toString(),
                            }, row);


                            let txtAlternateColor = null;
                            let bgColor: string = null;
                            if (config.bgColors && config.bgColors[colIndex]) {
                                bgColor = this._getColorValueFromPath(tableRowEntity, config.bgColors[colIndex]);
                                if (bgColor) {
                                    td_node.style.setProperty("--colBG", bgColor);

                                    try {
                                        if (this.isDarkColor(bgColor)) {
                                            txtAlternateColor = "var(--bright)";
                                        } else {
                                            txtAlternateColor = "var(--dark)";
                                        }
                                    } catch (ex) {
                                        txtAlternateColor = "unset";
                                    }
                                } else {

                                }
                            }

                            let txtColor = null;
                            if (config.txtColors && config.txtColors[colIndex]) {
                                txtColor = this._getColorValueFromPath(tableRowEntity, config.txtColors[colIndex], "TXT");

                            } if (txtColor) {
                                td_node.style.setProperty("--colTXT", txtColor);
                            } else {
                                // invertierte Farbe von oben nehmen:
                                if (config.bgColors && config.bgColors[colIndex]) {
                                    td_node.style.setProperty("--colTXT", txtAlternateColor);
                                }
                            }

                            if (config.alignmentsRow && config.alignmentsRow[colIndex]) {
                                this.UiModder.domStyle.set(td_node, "textAlign", config.alignmentsRow[colIndex]);
                            }

                            let contentNode: HTMLElement;

                            // wenn textoverflow is_enabled, müssen wir einen div in das td einsetzen, damit das textOverflow funzt
                            if (this.clipContentOverflow === true && this.selectedLayout?.allowLinebreak !== true) {


                                let td_div = this.UiModder.domConstruct.create("div", {
                                    "className": "overflowContainer",
                                    "innerHTML": null, // the formatter function below provides innerHTML
                                }, td_node);

                                if (config.alignmentsRow && config.alignmentsRow[colIndex]) {
                                    switch (config.alignmentsRow[colIndex]) {
                                        case "right":
                                            this.UiModder.domStyle.set(td_div, "justifyContent", "end");
                                            break;

                                        case "left":

                                            break;

                                        case "center":
                                        case "middle":
                                            this.UiModder.domStyle.set(td_div, "justifyContent", "center");
                                            break;
                                    }
                                }

                                if (config.alignmentsRow && config.alignmentsRow[colIndex]) {
                                    this.UiModder.domStyle.set(td_div, "textAlign", config.alignmentsRow[colIndex]);
                                }

                                contentNode = td_div;
                            } else {
                                // the formatter function below provides innerHTML
                                contentNode = td_node;
                            }

                            let cell: StaticTable.StaticTableCell<any> = {
                                colspan: td_colspan,
                                name: colnames[colIndex] ? colnames[colIndex] : propertynames[colIndex],
                                tableRow: rowLine,
                                entity: tableRowEntity,
                                propertyPath: propertynames[colIndex],
                                contentnode: contentNode,
                                tableCellNode: td_node,
                                value: outputValue,
                                displayValue: undefined,
                                valuepath: config.attributes[colIndex],
                                clickFct: null,
                                formatterConfig: cellFormatter
                            }
                            rowLine.cells.push(cell);


                            on(td_node, "click", lang.hitch(this, this._onClick_TableCell, rowLine, rowGroup, cell));
                            on(td_node, "contextmenu", lang.hitch(this, this._onClick_TableCellContextMenu, rowLine, rowGroup, cell));

                            let formattingHandled: boolean = false;
                            if (this.customCellFormatter) {
                                this._createSimpleCellValue(cell);

                                if (FeatureHelpers.hasFeature("debug/disableStaticTableCellFormatters")) {
                                    formattingHandled = true;
                                } else {
                                    try {
                                        //formattingHandled = this.customCellFormatter(cell) === true;
                                        let result = this.customCellFormatter(cell);
                                        if (typeof (result) == "string") {
                                            formattingHandled = true;
                                            result = TranslationHelpers.tryTranslate(result);
                                            cell.contentnode.innerHTML = result;
                                        }
                                        else if (result === true || result instanceof HTMLElement) formattingHandled = true;
                                        if (result instanceof HTMLElement) this.UiModder.domConstruct.place(result, cell.contentnode);
                                    }
                                    catch (ex) {
                                        console.error(this.id + ": formatter failed!", ex);
                                    }
                                }
                            }

                            if (formattingHandled != true) {
                                this._defaultTableRowFormatter(cell);
                            } else {
                                this._handleCellColor(cell);
                            }

                            if (!cell.tableCellNode.hidden) {
                                visibleIndex[currentRowCount].push(cell.tableCellNode);
                            }

                            var lastTdNode = td_node;

                        } // enf for cells of row

                        if (lastTdNode) {
                            this.UiModder.domClass.add(lastTdNode, "lastCol");
                        }

                        // ganz am Ende, nach der letzten Spalte: Actions einfügen falls gesetzt
                        let actions: Array<StaticTable._ActionRegistryEntry> = [];
                        for (let key in this.actionRegistry) {
                            let entry = this.actionRegistry[key];
                            if (entry.use === true) actions.push(entry);
                        }
                        if (actions.length) {

                            if (currentRowCount == 0) {
                                let actionsCol = this.UiModder.domConstruct.create("td", {
                                    "data-label": "",
                                    "data-colname": "#_rowActions_#",
                                    "className": "actionsColumn",
                                    "innerHTML": "",
                                    "colspan": "1",
                                }, row, "last");

                                this.UiModder.domStyle.set(actionsCol, "textAlign", "right");

                                let icon;

                                var sortControlsContainer = this.UiModder.domConstruct.create("div", {
                                    className: "flex_row_center actionsContainer",

                                }, actionsCol);

                                for (let entry of actions) {
                                    let btn = this.UiModder.domConstruct.create("button", {
                                        className: "rowAction hoverTxtPrimary secondaryText",
                                        innerHTML: entry.buttonLabel ? entry.buttonLabel : ""
                                    }, sortControlsContainer);;
                                    btn.setAttribute("data-action-name", entry.actionname);

                                    icon = DOMhelpers.createFontawesomeIcon((entry.iconClass ? entry.iconClass : "far fa-dot-circle rowAction"),
                                        entry.buttonLabel ? "right" : null,
                                        btn,
                                        "first");
                                    on(btn, "click", lang.hitch(this, this._onClick_TableRowAction, entry.actionname, rowGroup));

                                    this.UiModder.domStyle.set(btn, "order", entry.position);

                                    this.hideNode(btn);

                                    if (entry.title) {
                                        let tooltip = new Tooltip();
                                        tooltip.setup({
                                            targetnode: btn,
                                            content: entry.buttonLabel ? entry.buttonLabel : entry.title,
                                            subtitle: entry.buttonLabel ? entry.title : null,
                                            icon: entry.iconClass
                                        });
                                    }

                                    switch (entry.actionname) {
                                        case "movedown":
                                            // letzter Eintrag in der Liste kann nicht nach unten geschoben werden:
                                            if (entityIndex + 1 == entitiesCount) {
                                                this.disableNode(btn);
                                            }
                                            break;

                                        case "moveup":
                                            // erster Eintrag in der Liste kann nicht nach oben geschoben werben
                                            if (entityIndex == 0) {
                                                this.disableNode(btn);
                                            }
                                            break;

                                        case "select":
                                            if (currentSelectedEntites.indexOf(rowGroup.entity) != -1) {
                                                this.UiModder.domClass.replace(icon, "fas fa-check-circle accentTXT", "far fa-circle");
                                                rowGroup.selected = true;
                                                this.UiModder.domClass.add(rowGroup.rows[0].node, "selected");
                                            }
                                            break;
                                    }

                                    rowGroup.actions[entry.actionname] = {
                                        name: entry.actionname,
                                        node: btn,
                                        iconNode: icon,
                                        reg: entry
                                    };

                                    this._checkActionButtonEnablingState(entry.actionname, rowGroup);
                                }
                            }

                            // falls es weitere Zeilen gibt: colspan der letzten Spalte um eins erhöhen!
                            else {
                                let colspan = lastTdNode.colSpan;
                                colspan ? colspan++ : colspan = 2;
                                lastTdNode.colSpan = colspan;
                            }
                        }


                        currentRowCount++;

                        if (this.rowConfigs.length > 1 && currentRowCount == this.rowConfigs.length) {
                            let spacer: HTMLElement = this.UiModder.domConstruct.create("tr", { "class": "table_multilineSpacer topRow" }, tableBody);
                            this.UiModder.domConstruct.create("td", {
                                "colspan": this.maxColspan, //LH set this.maxColSpan ???
                                "data-tr_index": entityIndex,
                                "innerHTML": "",
                                "className": ""
                            }, spacer);
                        }

                    } // end for rows of entity

                    for (let rowKey in visibleIndex) {
                        let nodes = visibleIndex[rowKey];

                        let firstCol: HTMLElement = null;
                        let lastCol: HTMLElement = null;

                        if (nodes.length) firstCol = nodes.shift();
                        if (nodes.length) lastCol = nodes.pop();
                        else lastCol = firstCol;

                        if (firstCol) this.UiModder.domClass.add(firstCol, "firstVisible");
                        if (lastCol) this.UiModder.domClass.add(lastCol, "lastVisible");
                    }

                    if (this.showIndexColumn === true && indexCol) {
                        this.UiModder.domAttr.set(indexCol, "rowSpan", currentRowCount);
                    }

                    this.UiModder.domAttr.set(expanderCol, "rowSpan", currentRowCount);

                    this.setRowClick(this._rowClickFunction);

                    // falls auf der Group ein expandercallback hinterlegt ist:
                    let expanderReg = this.expanderRegistry[rowGroup.keyValue]

                    if (expanderReg && expanderReg.rowNode) {
                        this.setRowGroupExpanderContent(rowGroup.rowIndex, expanderReg.rowNode, expanderReg.currentExpandState);
                    } else if (this._defaultExpanderConfig?.expanderContentCallback) {
                        let result: HTMLElement | string | boolean = false;
                        if (typeof (this._defaultExpanderConfig.expanderContentCallback) == "boolean") {
                            result = this._defaultExpanderConfig.expanderContentCallback;
                        }  else {
                            result = this._defaultExpanderConfig.expanderContentCallback(rowGroup);
                        }
                        if (result) {
                            let contentElement: HTMLElement = null;
                            if (result instanceof HTMLElement) {
                                contentElement = result;
                            } else if (typeof (result) == "string") {
                                contentElement = this.UiModder.domConstruct.create("p", {
                                    className: "tableRowExpanderContent",
                                    innerHTML: result
                                });
                            }
                            this.setRowGroupExpanderContent(rowGroup.rowIndex, contentElement, false, this._defaultExpanderConfig?.expanderClickCallback);
                        }
                    }
                }

                else {
                    alert("table has no layout configuration set!");
                }

            }

            if (this.domNode.parentElement) {
                this._checkCellOverflow();
            }

            //falls data-cy nicht explizit von außen gesetzt wurde
            if (!this.tableRoot?.dataset.cy) {
                this.setCyAttribute("staticTable:" + (this.selectedLayout.name ?? ""));
            }

            this.emit("tableDrawn");

            //für Test Dom Event werfen - damit Test weiß, wann die table fertig zum Auslesen ist
            //eigener e2e-Name, damit es nicht mit dem Widget-Event this.emit("tableDrawn") kollidiert
            const tableEl = this.domNode;
            if (tableEl) {
                tableEl.dispatchEvent(
                    new CustomEvent("e2eTableNodeDrawn", {
                        detail: {
                            table: this,
                        },
                        bubbles: true,
                    })
                );
            }
         } catch (ex) {
            let tr = this.UiModder.domConstruct.create("tr", {
                tableBody
            });
            console.error(this.id + ": drawing table failed", ex);

            let td = this.UiModder.domConstruct.create("td", {
                innerHTML: "something went wrong while drawing table: " + ex,
                colspan: this.maxColspan.toString()
            }, tr);
        }


        if (this.data && this.data.length) {
            if (sortControlsContainer) {
                // Funktioniert so halb. Padding rechts fehlt dann aber...
                //// FAKE PLATZIEREN UND DIMENSIONEN AUSMESSEN!
                //let dummy = lang.clone(sortControlsContainer);
                //domStyle.set(dummy, "opacity", 0);
                //domStyle.set(dummy, "position", "absolute");
                //domConstruct.place(dummy, document.body);
                //console.debug(this.id + " sorting container?", dummy.clientWidth, dummy.scrollWidth, dummy);
                //this.tableRoot.style.setProperty("--sortingColumnWidth", dummy.scrollWidth.toString() + "px");

                //domConstruct.destroy(dummy);

            }
        } else {
            let tr = this.UiModder.domConstruct.create("tr", { className: "topRow" }, tableBody);
            let td = this.UiModder.domConstruct.create("td", { "colspan": this.maxColspan.toString(), className: "noEntries" }, tr);

            this.UiModder.domAttr.set(td, "innerHTML", this.translate("General__NoEntries"));
        }



        this.disableNode(this.tableRoot, false);
    }

    resetSelectedEntities() {
        for (let row of this.rowRegistry) {
            row.selected = false;
        }
    }

    selectRowGroup(rowGroup: StaticTable.StaticTableRowGroup<T>, selected: boolean) {
        rowGroup.selected = selected;
        this.drawTable();
    }

    private async _checkCellOverflow(targetRow?: StaticTable.StaticTableRow<T>) {
        if (this.clipContentOverflow === true && this.selectedLayout?.allowLinebreak !== true) {

            //ANM: wenn die Statictable noch nicht fertig im DOM platziert ist, dann sind clientWidth und scrollWidth 0
            // die Prüfung greift ins Leere...
            if (!targetRow) {
                for (let rowgrp of this.rowRegistry) {
                    for (let row of rowgrp.rows) {
                        this._checkCellOverflow(row);
                    }

                }

                return;
            }

            for (let cell of targetRow.cells) {
                let contentNode = cell.contentnode;
                let outputValue = cell.displayValue;
                
                if (contentNode.clientWidth < contentNode.scrollWidth) {

                    if (!contentNode.childElementCount) { // es darf keine Unterelemente geben, zb Buttons
                        this.UiModder.domClass.add(contentNode, "clickable");
                        contentNode.onclick = lang.hitch(this, this._showOverflowContent, contentNode, outputValue);
                    }
                }
            }
            
        }
    }

    private _onClick_TableRowAction(actionType: string,
        rowGroup: StaticTable.StaticTableRowGroup<any>,
        evt?: MouseEvent
    ): void {
        //console.log("_onClick_TableRowAction", actionType, rowGroup, evt.target);
        let entity = rowGroup.entity;
        let rowIndex = rowGroup.rowIndex;

        if (evt) evt.stopPropagation();

        // listName für Aktion
        for (let key in this.actionRegistry) {
            let entry = this.actionRegistry[key];

            if (entry.actionname == actionType) {
                switch (entry.actionname) {
                    case "moveup":
                        this.moveUp(rowGroup.rowIndex);
                        if (entry.callback) {
                            entry.callback(rowGroup);
                        }
                        break;

                    case "movedown":
                        this.moveDown(rowGroup.rowIndex);
                        if (entry.callback) {
                            entry.callback(rowGroup);
                        }
                        break;

                    case "edit":
                        if (entry.callback) {
                            entry.callback(rowGroup);
                        }
                        this.emit("edit", rowGroup);
                        break;

                    case "select":
                        this.toggleSelectRow(rowGroup);
                        if (entry.callback) {
                            entry.callback(rowGroup);
                        }
                        break;

                    case "delete":
                        if (this.store) {
                            this.store.deleteEntry(entity);
                        } else {
                            this.data.splice(rowIndex, 1);
                            this.emit("deleted", rowGroup);
                            this.emit("delete", rowGroup);
                            this.drawTable();
                        }
                        if (entry.callback) {
                            entry.callback(rowGroup);
                        }
                        break;

                    default:
                        if (entry.callback) {
                            entry.callback(rowGroup);
                        }
                        break;
                }

                break;
            }
        }
    }

    private toggleSelectRow(rowgroup: StaticTable.StaticTableRowGroup<any>) {
        this.selectRow(rowgroup, rowgroup.selected === true ? false : true);
    }
    selectEntity(entity: T) {
        this.selectRow(this.getRowGroupByKeyValue(entity));
    }

    private selectRow(rowgroup: StaticTable.StaticTableRowGroup<T>, selectState?: boolean) {
        if (selectState !== false) selectState = true;
        if (!rowgroup) return;

        rowgroup.selected = selectState;
        this.drawTable();

        this.emit("select");
    }

    /** Zähle alle Daten einmal durch und setzt die Reihenfolge auf das Sortingattribute. */
    private _recountData() {
        if (this.rowSortingAttr && this.data?.length) {
            let count = this.indexOffset;
            for (let entry of this.data) {

                if (entry[this.rowSortingAttr] != count) {
                    entry[this.rowSortingAttr] = count;

                    if (this.store) {

                        this.store.changeEntry(entry);
                    }
                }
                count++;
            }
        }
    }
    private moveDown(sourceIndex: number) {

        this._recountData();

        //nicht verwirren lassen: down heißt in der Liste nach unten, d.h. der Index wird GRÖSSER...
        let movedEntity = this.data[sourceIndex];
        let targetIndex = sourceIndex + 1;
        let targetEntity = this.data[targetIndex];

        if (targetIndex >= this.data.length) {
            return;
        }

        if (!targetEntity) return;

        this.data.splice(sourceIndex, 1); // Entity aus dem Array rausnehsmen
        // Elemente danach rücken auf den ursprünglichen Index zurück
        this.data.splice(targetIndex, 0, movedEntity); // Entity an die neue Stelle einfügen

        let targetRowsortValue = targetEntity[this.rowSortingAttr];
        let sourceRowsortValue = movedEntity[this.rowSortingAttr];

        movedEntity[this.rowSortingAttr] = targetRowsortValue;// targetIndex + this.indexOffset;
        targetEntity[this.rowSortingAttr] = sourceRowsortValue;

        if (this.store) {
            let result1 = this.store.changeEntry(movedEntity);
            let result2 = this.store.changeEntry(targetEntity);

            if (result1 == true && result2 == true) return;
        }

        this.drawTable();

        if (typeof (this.rowSortingCallback) == "function") this.rowSortingCallback(this.rowRegistry[targetIndex], this.rowRegistry[sourceIndex]);
    }

    private moveUp(sourceIndex: number) {

        this._recountData();

        let movedEntity = this.data[sourceIndex];
        let targetIndex = sourceIndex - 1;

        if (targetIndex < 0) return;

        let targetEntity = this.data[targetIndex];

        this.data.splice(sourceIndex, 1); // Entity aus dem Array rausnehmen
        // Elemente danach rücken auf den ursprünglichen Index zurück
        this.data.splice(targetIndex, 0, movedEntity); // Entity an die neue Stelle einfügen

        let targetRowsortValue = targetEntity[this.rowSortingAttr];
        let sourceRowsortValue = movedEntity[this.rowSortingAttr];

        movedEntity[this.rowSortingAttr] = targetRowsortValue;// targetIndex + this.indexOffset;
        targetEntity[this.rowSortingAttr] = sourceRowsortValue; // sourceIndex + this.indexOffset;

        if (this.store) {
            let result1 = this.store.changeEntry(movedEntity);
            let result2 = this.store.changeEntry(targetEntity);

            if (result1 == true && result2 == true) return;
        }

        this.drawTable();

        if (typeof (this.rowSortingCallback) == "function") this.rowSortingCallback(this.rowRegistry[targetIndex], this.rowRegistry[sourceIndex]);
    }

    private _showOverflowContent(targetNode: HTMLElement, outputValue: any, evt: Event) {

        evt.stopPropagation();

        if (typeof (outputValue) != "string") return;

        //this.closeAllOverflowContents();

        //let tableCol = targetNode.parentElement;
        //this.UiModder.domClass.add(targetNode, "table_dropdown");

        //let dropdown = this.UiModder.domConstruct.create("div",
        //    {
        //        "className": "table_dropdown_content"
        //    },
        //    tableCol);

        //this.UiModder.domClass.add(targetNode, "clicked");

        //dropdown.onclick = function (e) {
        //    e.stopPropagation(); // globalen Klick unterbinden!
        //}

        let outputValueHTML = this.stringReplaceAll(outputValue, "\r\n", "<br>");

        let container = this.UiModder.domConstruct.create("div", { className: "paddingSmall staticTableCellTooltip flex_row_top" });
        let content = this.UiModder.domConstruct.create("div", { className: "paddingSmall content", innerHTML: outputValueHTML }, container);
        let copyButton = this.UiModder.domConstruct.create("button", {
            className: "mds-button-base sL4 hoverDark w3-ripple paddingSmall round margin-right",
            title: this.translate("General_Copy"),
        }, container, "first");
        this.createFontawesomeIcon("far fa-clone", "", copyButton);

        on(copyButton, "click", lang.hitch(this, this._onClick_CopyHoverContent, outputValue));

        //    // einen dropdown element einbauen, damit der ganze Txtonclock angezeigt wird
        //    dropdown.innerHTML = outputValue;

        //    evt.stopPropagation();
        let floatingContainer = new FloatingContainer();
        this.UiModder.domClass.add(floatingContainer.domNode, "brightOpaqueBG round w3-card border complimentaryBorder")
        floatingContainer.open(evt, container);
    }

    private _onClick_CopyHoverContent(value: string, evt: MouseEvent) {
        //if (evt) {
        //    let isRightMB = evt.button == 2;
        //    if (!isRightMB) {
        //        return;
        //    }
        //}

        //let menu = new Menu();
        //menu.open(evt, [{
        //    label: "kopieren",
        //    callback: lang.hitch(this, this._onClick_CopyHoverContentValue, value),
        //    icon: "fas fa-copy"
        //}]);
        navigator.clipboard.writeText(value);

        evt.stopPropagation();

    }



    // Eine oder mehrere ZeilenKonfiguraiotnen hinzufügen.
    addLineConfig(rowConfig: StaticTable.RowConfig): void {

        if (!this.selectedLayout) {
            // fals nicht gesetzt: leeres Layout faken
            this.selectedLayout = {
                name: "default",
                label: "default",
                rows: []
            }
        }

        this._addLineConfig.apply(this, arguments);
        if (this.data) {
            this.drawTable();
        }
    }

    private _addLineConfig(rowConfig: StaticTable.RowConfig): void {

        if (rowConfig) {

            // arrays angleichen!
            let colCountMax = 0;
            let count = 0;

            if (rowConfig.colNamesInternal) {
                if (rowConfig.colNamesInternal.length > colCountMax) colCountMax = rowConfig.colNamesInternal.length;

                if (!rowConfig.attributes) {
                    rowConfig.attributes = [];
                    for (let colname of rowConfig.colNamesInternal) {
                        rowConfig.attributes.push(colname);
                    }
                }


            }

            if (rowConfig.attributes) {
                if (rowConfig.attributes.length > colCountMax) colCountMax = rowConfig.attributes.length;

                if (!rowConfig.colNamesInternal) {
                    rowConfig.colNamesInternal = [];
                    for (let propName of rowConfig.attributes) {
                        rowConfig.colNamesInternal.push(propName);
                    }
                }
            }

            if (rowConfig.cellFormatterConfigs) {
                rowConfig.cellFormatterConfigs = [];
            }

            if (!rowConfig.colspans) {
                rowConfig.colspans = [];
            }
            if (rowConfig.colspans) {
                if (rowConfig.colspans.length > colCountMax) colCountMax = rowConfig.colspans.length;

                // erweitern
                if (rowConfig.colspans.length < colCountMax) {
                    for (let index = 0; index < rowConfig.colNamesInternal.length; index++) {
                        if (index >= rowConfig.colspans.length) {
                            rowConfig.colspans.push(1);
                        }
                    }
                }
            }

            if (rowConfig.headings) {
                if (rowConfig.headings.length > colCountMax) colCountMax = rowConfig.headings.length;
            }

            this.rowConfigs.push(rowConfig)

            this.multiRowEntities = this.rowConfigs.length > 1;

            if (colCountMax > this.maxColspan) this.maxColspan = colCountMax; // tatsächliche Spaltenzahl. colspans bringen ja nix, wenns mehr ergibt als wirklich spalten sind
        }

        //this.drawTable();
    }

    //Eine klasse für die rows mit bestimmeten entity properties setzen
    setConditionalStyleClass(targetAttribute: string, targetValue: any, rowClass: string): void {

        for (let rowEntry of this.rowRegistry) {
            let entity = rowEntry.entity;

            for (let row of rowEntry.rows) {
                for (let cell of row.cells) {

                    let entityValue = cell.value;

                    if (targetAttribute) {
                        entityValue = EntityHelpers.getComplexProperty(entity, targetAttribute);
                    }

                    if (entityValue == targetValue || (targetValue == "*" && entityValue != null)) {

                        for (let row of rowEntry.rows) {

                            this.UiModder.domClass.add(row.node, rowClass);
                        }
                    }
                }
            }
        }
    }


    // einen (string), mehrere (string[]), oder alle (null/undefined) row klassen entfernen (!!!In der ganzen Tabelle!!!), die durch this.setRowClass_Based_On_EntityProperty gesetzt waren
    _removeCustomRowClasses(rowClasses?: string | string[]): void {
        let classesToRemove: string[] = [];
        let tableRows: HTMLCollectionOf<Element> = this.domNode.getElementsByTagName("tr");

        if (rowClasses && typeof rowClasses == "string") {
            classesToRemove.push(<string>rowClasses);
        } else if (rowClasses && rowClasses.length) {
            classesToRemove = <string[]>rowClasses;
        } else {
            // wenn kein valides argument vorhanden - remove all classes
            classesToRemove = this.customRowClasses;
        }

        for (let i = 0; i < tableRows.length; i++) {
            for (let rowClass of classesToRemove) {
                this.UiModder.domClass.remove(tableRows[i], rowClass);
                this.customRowClasses.splice(this.customRowClasses.indexOf(rowClass), 1);
            }
        }
    }

    setTableLayout(layout: StaticTable.Layout): void {

        this.setLayout(layout);
    }

    //works only if the table layout is "auto"
    private setColumnWidth(index: number, width: number): void {

        let theadCollection = this.tableRoot.getElementsByTagName("thead");
        let thForIndex = theadCollection[0].firstChild.childNodes[index];

        this.UiModder.domStyle.set(<HTMLElement>thForIndex, "width", width + "px");
    }

    /**
     * @deprecated bitte getRowGroupByKeyValue verwenden
     * OBSOLET! bitte getRowGroupByKeyValue verwenden!!
     * nur noch vorhanden, damit evtl. alte Skripts noch damit arbeiten können
     */
    getRowByKeyValue(value: any, targetPropertyName?: string): StaticTable.StaticTableRowGroup<T> {
        return this.getRowGroupByKeyValue(value, targetPropertyName);
    }
    getRowGroupByKeyValue(value: any, targetPropertyName?: string): StaticTable.StaticTableRowGroup<T> {
        if (!targetPropertyName) {
            targetPropertyName = this.keyAttribute;
        }

        for (let row of this.rowRegistry) {
            if (row.entity) {
                if (row.entity[targetPropertyName] == value) {
                    return row;
                }
            }
        }

        return null;
    }

    /**
     * OBSOLET! bitte getRowGroupByKeyValue verwenden!!
     * nur noch vorhanden, damit evtl. alte Skripts noch damit arbeiten können
     */
    private getRow(rowIndex: number): StaticTable.StaticTableRowGroup<T> {
        return this.getRowGroup(rowIndex);
    }
    getRowGroup(rowIndex: number): StaticTable.StaticTableRowGroup<T> {
        for (let registryObj of this.rowRegistry) {
            if (registryObj.rowIndex == rowIndex) {
                return registryObj;
            }
        }

        return null;
    }

    getRowEntity(rowIndex: number): T {
        let regEntry = this.getRowGroup(rowIndex);

        if (regEntry) {
            return regEntry.entity;
        }

        return null;
    }

    getCell(rowgroupIndex: number, colname: string): StaticTable.StaticTableCell<T> {
        let group = this.getRowGroup(rowgroupIndex);

        if (group) {
            for (let row of group.rows) {
                for (let cell of row?.cells) {
                    if (cell.name == colname) return cell;
                }
            }
        }
        return null;
    }
    getCellByKeyValue(keyvalue: any, colname: string): StaticTable.StaticTableCell<T> {
        let group = this.getRowGroupByKeyValue(keyvalue);

        if (group) {
            for (let row of group.rows) {
                for (let cell of row?.cells) {
                    if (cell.name == colname) return cell;
                }
            }
        }
        return null;
    }


    setHeaderColor(bgColor: string, txtColor: string): void {
        this.headerBgColor = bgColor;
        this.headerTxtColor = txtColor;
        if (this.tableRoot.innerHTML) this.createTableHead();
    }

    setStickyHeader(bool: boolean): void {
        this.stickyHeader = bool;
        if (this.tableRoot.innerHTML) this.createTableHead();
    }

    setVerticalAlign(target: "bottom" | "middle" | "top") {
        this.UiModder.domClass.toggle(this.domNode, "vBottom", target === "bottom");
        this.UiModder.domClass.toggle(this.domNode, "vMiddle", target === "middle");
        this.UiModder.domClass.toggle(this.domNode, "vTop", target === "top");
    }

    // Label == Überschricht
    // Getters und Setters

    setGroupingEnabled(bool: boolean, parameterName?: string): void {
        this.groupingEnabled = bool;

        if (bool && parameterName) this.setGroupingParameter(parameterName);
        if (bool === false) this.setGroupingParameter(null);
    }
    /**
     * Stellt die Datengruppierung ein. Achtung: Rowsorting-Buttons können diese Einstellung aushebeln.
     * @param propertyName Name eines Properties, das pro Datensatz ausgelesen und als Überschrift dargestellt wird. Die Daten werden nach diesem Property sortiert.
     * @param labelProperty Optional: Alternatives Labelproperty, das pro Datensatz ausgelesen wird und für die Überschrift genutzt. Dies ändert nicht die Sortierreihenfolge.
     * @param mappedGroupValues Optional: Definierte Gruppierungswerte
     * @param mappedGroupLabels Optional: Definierte Gruppenlabels, die zu den definierten Gruppierungswerten gemapped sind und das Labelproperty überdefinieren.
     */
    setGroupingParameter(propertyName: string, labelProperty?: string, mappedGroupValues?: Array<any>, mappedGroupLabels?: Array<string>): void {
        this.groupingProperty = propertyName;
        this.groupingLabelProperty = labelProperty;

        if (mappedGroupValues?.length && mappedGroupLabels?.length) {
            this.groupingValues = mappedGroupValues;
            this.groupingLabels = mappedGroupLabels;
        }

        if (propertyName && !this.groupingEnabled) {
            this.groupingEnabled = true;
        }

        if (!propertyName) {
            this.groupingEnabled = false;
        }
    }


    setContentOverflowClip(bool: boolean): void {
        this.clipContentOverflow = bool;
    }

    setSortDirection(direction: "ASC" | "DESC"): void {
        this.sortDirection = direction;
    }


    private _redrawTimeoutHandle: any = null;
    updateEntity(newEntityData: T, rowIndex?: number) {
        if (!newEntityData) return;
        if (!this.keyAttribute && typeof rowIndex != "number") return;
        if (!this.data || !this.data.length) return;

        if (rowIndex == null || typeof (rowIndex) == "undefined") rowIndex = this.getRowGroupByKeyValue(newEntityData[this.keyAttribute])?.rowIndex;

        if (!newEntityData[this.keyAttribute] && typeof rowIndex != "number") return;

        // das ist inzwischen nur quick & dirty - immer die ganze Tabelle neu zeichnen ist vielleicht nicht so optimal


        if (typeof (rowIndex) == "number" && rowIndex >= 0) {
            let row = this.getRowGroup(rowIndex);

            if (row) {
                row.entity = newEntityData;
                for (let line of row.rows) {
                    for (let cell of line.cells) {
                        cell.entity = newEntityData;
                        if (cell.propertyPath) {
                            //outputValue = this.PitHelper.getEntityAttributeValue(tableRowEntity, propertynames[colIndex], "json");
                            cell.value = EntityHelpers.getComplexProperty(cell.entity, cell.propertyPath);
                        } else {
                            cell.value = "";
                        }

                        this.UiModder.domConstruct.empty(cell.contentnode);
                        let formattingHandled: boolean = false;
                        if (this.customCellFormatter) {
                            if (FeatureHelpers.hasFeature("debug/disableStaticTableCellFormatters")) {
                                formattingHandled = true;
                            } else {
                                try {
                                    //formattingHandled = this.customCellFormatter(cell) === true;
                                    let result = this.customCellFormatter(cell);
                                    if (typeof (result) == "string") {
                                        formattingHandled = true;
                                        result = TranslationHelpers.tryTranslate(result);
                                        cell.contentnode.innerHTML = result;
                                        cell.displayValue = result;
                                    }
                                    else if (result === true || result instanceof HTMLElement) formattingHandled = true;
                                    if (result instanceof HTMLElement) this.UiModder.domConstruct.place(result, cell.contentnode);
                                }
                                catch (ex) {
                                    console.error(this.id + ": formatter failed!", ex);
                                }
                            }
                        }

                        if (formattingHandled != true) {
                            this._defaultTableRowFormatter(cell);
                        }

                    }

                    this._checkCellOverflow(line);
                }

                if (this.data.length > rowIndex) {
                    this.data[rowIndex] = newEntityData;
                }

                return;

            } else {
                // keine Row. Datensatz neu?
                this._initRowSortingAttributes(); // Sortierattribute vervollständigen
                // dann weiter, Tabelle wird neu gezeichnet
            }
        }

        let keyValue = newEntityData[this.keyAttribute];
        if (typeof keyValue == "undefined") {

        } else {

            if (this._redrawTimeoutHandle != null) {
                clearTimeout(this._redrawTimeoutHandle);
                this._redrawTimeoutHandle = null;
            }

            this.UiModder.domClass.add(this.tableRoot, "w3-disabled");

            let newDataArray = [];
            for (let existingData of this.data) {
                let value = existingData[this.keyAttribute];
                if (value != keyValue) {
                    newDataArray.push(existingData);
                } else {
                    newDataArray.push(newEntityData);
                }
            }

            this.data = newDataArray;

            this._redrawTimeoutHandle = setTimeout(lang.hitch(this, this.drawTable), 150);
        }
    }

    removeRow(rowGroupIndex: number, keepData?: boolean) {
        let rowGroup = this.getRowGroup(rowGroupIndex);

        if (keepData !== true) {
            if (this._redrawTimeoutHandle != null) {
                clearTimeout(this._redrawTimeoutHandle);
                this._redrawTimeoutHandle = null;
            }


            let targetEntity = this.getRowEntity(rowGroupIndex);
            let keyValue = targetEntity[this.keyAttribute];
            for (let i = 0; i < this.data.length; i++) {
                let entity = this.data[i];
                if (entity[this.keyAttribute] == keyValue) {
                    this.data.splice(i, 1);
                    break;
                }
            }

            this._redrawTimeoutHandle = setTimeout(lang.hitch(this, this.drawTable), 150);

        } else {
            if (rowGroup) {
                for (let row of rowGroup.rows) {
                    this.UiModder.domConstruct.destroy(row.node);
                }

                this.rowRegistry.splice(rowGroupIndex, 1);


            }
        }


    }

    private _onStore_Added(entity: T) {

        let data = this.store.getCurrentCompleteList();

        this.setData(data, this.store.getKeyAttribute());
    }

    private _onStore_EntityChanged(entity: any) {
        try {
            let expanderReg = this.expanderRegistry[entity[this.keyAttribute]];
            if (expanderReg && this._defaultExpanderConfig.entityChangeCallback) {
                // nur wenns wirklich schon erstellt wurde:
                if (expanderReg.isSetup) {
                    this._defaultExpanderConfig.entityChangeCallback(expanderReg.rowGroup);
                }
            }
        } catch (ex) {

        }
    }
    private _onStore_Changed(entitylist: Array<any>) {
        let data = this.store.getCurrentCompleteList();

        this.setData(data, this.store.getKeyAttribute());
    }

    private _onStore_Deleted(entity: any) {

        let data = this.store.getCurrentCompleteList();

        this.setData(data, this.store.getKeyAttribute());
    }

    setupFromStore(store: MdsLax<InstanceType<typeof EntityStore<T>>>, displaynameAttribute?: string): void {
        if (!store) return;

        let data = store.getCurrentCompleteList();

        this.setData(data as Array<T>, store.getKeyAttribute())

        if (this.store == store) return;
        this.store = store;
        //this.store.on( "added", lang.hitch(this, this._onStore_Added));
        //this.store.on("changed", lang.hitch(this, this._onStore_Changed));
        //this.store.on("deleted", lang.hitch(this, this._onStore_Deleted));
        this.store.on("entityChange", lang.hitch(this, this._onStore_EntityChanged));
        this.store.on("change", lang.hitch(this, this._onStore_Changed));
        this.store.on("dataset", lang.hitch(this, this._onStore_Changed));
    }

    setAdditionalSortingConfig(config: AdditionalSortingConfig) {

        this.additionalSortingConfig = config;
    }
    runAdditionalSorting(config?: AdditionalSortingConfig) {
        if (config) this.additionalSortingConfig = config;
        if (this.additionalSortingConfig == null) return;

        const sortConfigFnc = (a, b) => {
            let mod = this.additionalSortingConfig.ascending ? 1 : -1;

            for (var i = 0; i < this.additionalSortingConfig.sortingAttributeNames.length; i++) {
                let attrName = this.additionalSortingConfig.sortingAttributeNames[i]

                if (a[attrName] < b[attrName]) return -1 * mod;
                if (a[attrName] > b[attrName]) return 1 * mod;
            }

            //if (a[this.rowSortingAttr] < b[this.rowSortingAttr]) return -1 * mod;
            //if (a[this.rowSortingAttr] > b[this.rowSortingAttr]) return 1 * mod;

            return 0;
        };
        this.data.sort(sortConfigFnc);
        this._recountData();
        this.drawTable();
    }

    setData(data: Array<T>, IDattribute: string = "ID", displaynameAttribute?: string, completeCount?: number, offset?: number): void {
        this.data = data;
        if (!this.expanderRegistry) {
            this.expanderRegistry = {};
        }

        if (displaynameAttribute) this.labelProperty = displaynameAttribute;

        if (typeof (completeCount) == "number" && typeof (offset) == "number") {
            this.indexOffset = offset;
            this.indexCount = completeCount;
        }

        if (IDattribute) this.keyAttribute = IDattribute;
        //if (this.labelAttribute) {
        //    if (this.selectedLayout) {
        //        this.selectedLayout.labelProperty = displaynameAttribute;
        //    }
        //}

        if (this.rowSortingAttr) {
            this._initRowSortingAttributes();
        }

        if (this.selectedLayout) {
            this.sortData();
            if (this.customSortFunction) {
                this.customSortData();
            }
            this.drawTable();
        }
    }


    private _onClick_SelectLayout(evt: MouseEvent) {
        if (!this.availableLayouts || !this.availableLayouts.length || this.availableLayouts.length < 2) {
            return;
        }

        let menu = new FloatingMenu();

        for (let layout of this.availableLayouts) {
            menu.addEntry({
                callback: lang.hitch(this, this._onClick_Layout, layout),
                label: layout.label ? layout.label : layout.name,
                enabled: layout.name != this.selectedLayout.name,
                icon: layout.name == this.selectedLayout.name ? "fas fa-check" : null,
                //heading: this.translate("General_TableLayout"]
            });
        }

        menu.open(evt, null, this.translate("General_TableLayout"));
    }
    getSelectedLayout(): StaticTable.Layout {
        return this.selectedLayout;
    }
    addLayout(layout: StaticTable.Layout) {

        let index = this.getLayoutIndexByName(layout.name);
        if (index != -1) {
            return;
        }

        this.availableLayouts.push(layout);

        this.hideNode(this.layoutSelectcontainer, this.availableLayouts.length <= 1);
        if (this.layoutSelectButton) this.hideNode(this.layoutSelectButton.domNode, this.availableLayouts.length <= 1);

        if (!this.selectedLayout) {
            this.setLayout(layout);
        }
    }

    removeLayout(layout: StaticTable.Layout) {
        if (layout) this.removeLayoutByName(layout.name);
    }

    removeLayoutByName(name: string) {

        let index = this.getLayoutIndexByName(name);
        if (index === -1) {
            return;
        }

        let layout = this.availableLayouts[index];

        this.availableLayouts.splice(index, 1);

        this.hideNode(this.layoutSelectcontainer, this.availableLayouts.length <= 1);
        if (this.layoutSelectButton) this.hideNode(this.layoutSelectButton.domNode, this.availableLayouts.length <= 1);


        if (this.selectedLayout === layout) {
            this.selectedLayout = null;
        }
    }

    private getLayoutIndexByName(layoutName: string) {
        for (let i = 0; i < this.availableLayouts.length; i++) {
            if (this.availableLayouts[i].name == layoutName) {
                return i;
            }
        }

        return -1;
    }

    private _onClick_Layout(layout: StaticTable.Layout) {
        this.setLayout(layout);
        this.emit("layoutChange", layout);
    }
    setLayoutByName(layoutName: string): boolean {
        let index = this.getLayoutIndexByName(layoutName);
        if (index != -1) return this.setLayout(this.availableLayouts[index]);
        else return false;
    }
    setLayout(layout: StaticTable.Layout): boolean {

        if (!layout) {
            return false;
        }

        if (this.selectedLayout && this.selectedLayout.name == layout.name) {
            return true;
        }

        if (this.getLayoutIndexByName(layout.name) == -1) {
            this.addLayout(layout);
            return true;
        }

        this.rowConfigs = [];

        this.selectedLayout = layout;

        this.layoutSelectButton.setLabel(layout.label);

        this.clearSearch();

        this.maxColspan = 0;
        for (let config of layout.rows) {
            this._addLineConfig(config);
        }

        if (layout.layoutStyle) {
            this.tableLayout = layout.layoutStyle;
        }
        if (layout.collapsible) {

        }

        if (layout.name) {

        }

        //if (layout.label) {
        //    this.setLabel(layout.label);
        //} else {
        //    this.setLabel(null);
        //}

        this.quicksearchEnabled = layout.enableQuicksearch === true;
        this.UiModder.domClass.toggle(this.quicksearchContainer, "w3-hide", this.quicksearchEnabled != true);
        if (this.quicksearchEnabled) {
            if (layout.quickSearchPlaceholder) {
                this.inputQuicksearch.setPlaceholder(layout.quickSearchPlaceholder);
            } else {
                this.inputQuicksearch.setPlaceholder(this.translate("General_Search"))
            }

            this.inputQuicksearch.setValue("", true);
        }

        if (this.data) {
            this.drawTable();

            for (let key in this.expanderRegistry) {
                let reg = this.expanderRegistry[key];
                if (reg?.cellNode) this.UiModder.domAttr.set(reg.cellNode, "colspan", this.maxColspan.toString());
            }
        }

        return true;
    }

    getLayoutSelectorButton(forceIfInvisible?: boolean): MdsLax<InstanceType<typeof Button>> {
        if (this.availableLayouts?.length > 1 || forceIfInvisible == true) {
            this.hideNode(this.layoutSelectcontainer);
            return this.layoutSelectButton;
        }
    }

    private _afterDefaultTableRowFormatter(result: boolean) {

    }

    setFormatter(Formatter: StaticTable.formatterCallback<T>): void {
        this.customCellFormatter = Formatter;
        if (this.selectedLayout && this.data) {
            this.drawTable();
        }
        /*aspect.after(this, "tableRowFormatter", this._afterDefaultTableRowFormatter);*/
    }

    setHeadingLabelFormatter(Formatter: Function): void {
        this.headingLabelFormatter = Formatter;
    }

    private _rowClickFunction: StaticTable.rowclickCallback;
    /**
     * Callback für Click auf eine Tabellenzeile. Aufgerufen wird das Callback mit diesen Parametern:
     * StaticTable.StaticTableRow, StaticTable.StaticTableRowGroup, Klick-Event
     */
    setRowClick(ClickFct: StaticTable.rowclickCallback<T>, targetRowIndex?: number, targetLineIndex?: number): void {

        this._rowClickFunction = ClickFct;

        for (let rowGroup of this.rowRegistry) {
            if ((rowGroup.rowIndex == targetRowIndex && targetRowIndex) || !targetRowIndex) {
                for (let singleRow of rowGroup.rows) {
                    if (targetLineIndex == singleRow.lineIndex || !targetLineIndex) {
                        if (ClickFct) {
                            singleRow.clickFct = ClickFct; // lang.partial(ClickFct, rowGroup, singleRow)
                        } else {
                            singleRow.clickFct = null;
                        }

                        if (targetLineIndex) {
                            break;
                        }
                    }
                }

                this._setRowClickStyles(rowGroup);

                if (targetRowIndex) {
                    break;
                }
            }
        }
    }

    setCellClick(ClickFct: StaticTable.cellclickCallback<T>, colname: string, targetRowIndex?: number) {
        for (let rowGroup of this.rowRegistry) {
            if (!targetRowIndex || targetRowIndex == rowGroup.rowIndex) {
                for (let rowLine of rowGroup.rows) {
                    for (let cell of rowLine.cells) {
                        if (colname == cell.name) {
                            cell.clickFct = ClickFct;
                        }
                    }
                }
                this._setRowClickStyles(rowGroup);

                if (targetRowIndex) {
                    break;
                }
            }
        }
    }

    private _onMouseEnter_ExpanderRow(rowValue: string, evt: MouseEvent) {
        let reg = this.expanderRegistry[rowValue];
        if (reg && reg.rowGroup) {
            this._onMouseEnter_TableRow(reg.rowGroup.rows[0], null, evt);
        }
    }
    private _onMouseLeave_ExpanderRow(rowValue: string, evt: MouseEvent) {
        let reg = this.expanderRegistry[rowValue];
        if (reg && reg.rowGroup) {
            this._onMouseLeave_TableRow(reg.rowGroup.rows[0], null, evt);
        }
    }
    private _onMouseEnter_TableRow(rowLine: StaticTable.StaticTableRow<any>, group: StaticTable.StaticTableRowGroup<any>, evt: MouseEvent) {
        for (let row of rowLine.rowGroup.rows) {
            this.UiModder.domClass.add(row.node, "hover");
        }

        let reg = this.expanderRegistry[rowLine.rowGroup.keyValue];
        if (reg && reg.rowNode) this.UiModder.domClass.add(reg.rowNode, "hover");
    }
    private _onMouseLeave_TableRow(rowLine: StaticTable.StaticTableRow<any>, group: StaticTable.StaticTableRowGroup<any>, evt: MouseEvent) {
        for (let row of rowLine.rowGroup.rows) {
            this.UiModder.domClass.remove(row.node, "hover");
        }

        let reg = this.expanderRegistry[rowLine.rowGroup.keyValue];
        if (reg && reg.rowNode) this.UiModder.domClass.remove(reg.rowNode, "hover");
    }
    private _onClick_TableRow(row: StaticTable.StaticTableRow<any>, group: StaticTable.StaticTableRowGroup<any>, evt: MouseEvent) {
        if (typeof (row.clickFct) == "function") {
            row.clickFct(row, group, evt);
            this.emit("rowClicked");
            if (evt) {
                evt.stopPropagation();
            }
        }
    }

    private _onClick_TableCell(row: StaticTable.StaticTableRow<any>, rowGroup: StaticTable.StaticTableRowGroup<any>, cell: StaticTable.StaticTableCell<any>, evt: MouseEvent) {
        if (typeof (cell.clickFct) == "function") {
            cell.clickFct(cell, rowGroup, evt);
            if (evt) {
                evt.stopPropagation();
            }
        }
    }

    private _rowContextMenu: MdsLax<InstanceType<typeof FloatingMenu>>;

    private _onClick_TableCellContextMenu(rowLine: StaticTable.StaticTableRow<any>,
        row: StaticTable.StaticTableRowGroup<any>,
        cell: StaticTable.StaticTableCell<any>,
        evt: MouseEvent) {

        if (this._rowContextMenu) {
            this._rowContextMenu.close();
            this._rowContextMenu = null;
        }

        if (row.actions?.length) {
            evt.preventDefault();

            let menu = new FloatingMenu();


            for (let key in row.actions) {
                let action = row.actions[key];
                menu.addEntry({
                    callback: lang.hitch(this, this._onClick_TableRowAction, action.name, row, evt),
                    label: action.reg.title ? action.reg.title : "",
                    icon: action.reg.iconClass
                });
            }

            menu.open(evt, null, null);
            menu.on("close", lang.hitch(this, this._onCloseContextMenu));
            this._rowContextMenu = menu;
        }

    }
    private _onCloseContextMenu() {
        if (this._rowContextMenu) {
            this._rowContextMenu.close();
            this._rowContextMenu = null;
        }
    }

    private _setRowClickStyles(row: StaticTable.StaticTableRowGroup<T>) {
        for (let i = 0; i < row.rows.length; i++ ){
            let line = row.rows[i];
            if (line.clickFct) {
                line.node.classList.add("clickable");
            } else {
                if (line.node.classList.contains("clickable") == true){
                    line.node.classList.remove("clickable");
                }
            }

            for (let j = 0; j < line.cells.length; j++) {
                let cell = line.cells[j];
                if (cell.clickFct) {
                    cell.tableCellNode.classList.add("clickable");
                } else {
                    //nur durch remove brauchen wir 3 sekunden laenger bei 16k zellen.
                    //cell.tableCellNode.classList.remove("clickable");
                }
            }
        }
    }

    /** Gibt die Anzahl der Datensätze zurück */
    getRowCount(): number {
        return this.rowRegistry.length;
    }

    /**
     * Displayname einer Rowgroup zurückgeben. Entspricht dem Attributwert des Label-Attributs je nach gewähltem Layout.
     */
    getEntityDisplayName(entityId: string): string {
        let rowGroup: StaticTable.StaticTableRowGroup<any> = this.getRowGroupByKeyValue(entityId);;

        if (rowGroup) {
            if (rowGroup.entity && rowGroup.entity[this.keyAttribute] == entityId) {
                let value: string = null;
                if (this.selectedLayout && this.selectedLayout.labelProperty) {
                    value = rowGroup.entity[this.selectedLayout.labelProperty];
                }

                if (!value) {
                    if (this.labelProperty) {
                        value = rowGroup.entity[this.labelProperty];
                    }
                }
                if (!value) {
                    value = rowGroup.displayname;
                }

                if (value) {
                    rowGroup.displayname = value;
                    return value;
                }
                else {
                    for (let property in rowGroup.entity) {
                        let value: any = rowGroup.entity[property];
                        if (typeof (value) == "string") {
                            return value;
                        }
                    }
                }

            }
        }

        return "";
    }

    // Dojo

    //_setFormatterAttr(Formatter: formatterCallback): void {
    //    this.setFormatter(Formatter);
    //}
    private _setGroupingEnabledAttr(bool: boolean): void {
        this.setGroupingEnabled(bool);
    }
    private _setGroupingParameterAttr(param: string): void {
        this.setGroupingParameter(param);
    }

    private _seTextOverflowAttr(bool): void {
        this._setContentOverflowAttr(bool);
    }
    private _setContentOverflowAttr(bool): void {
        this.setContentOverflowClip(bool);
    }
    private _setSortDirectionAttr(direction: "ASC" | "DESC"): void {
        this.setSortDirection(direction);
    }

    //_setDataAttr(data: Array<object>, IDattribute: string = "ID", displaynameAttribute?: string): void {
    //    this.setData(data, IDattribute, displaynameAttribute);
    //}

    private _onChange_InputQuickSearch(value: string, evt: Event) {
        //console.log("_onChange_InputQuickSearch", value, evt);

        this._handleSearchDelayed(value);
    }

    private _searchDelayHandle: any = null;
    private _previousSearchValue: string = "";
    private _handleSearchDelayed(value: string) {
        if (this._searchDelayHandle != null) {
            clearTimeout(this._searchDelayHandle);
        }

        this._searchDelayHandle = setTimeout(lang.hitch(this, this._handleSearch, value), 400);
    }

    private _onClick_ClearSearch(evt: MouseEvent) {
        if (evt) evt.stopPropagation();
        this.clearSearch();
    }

    private clearSearch() {
        if (this._searchDelayHandle != null) {
            clearTimeout(this._searchDelayHandle);
        }
        this.inputQuicksearch.setValue("", true);
        this._handleSearch("");
    }

    private _handleSearch(searchText: string) {

        if (searchText != this._previousSearchValue) {
            this._previousSearchValue = searchText;
        } else {
            return;
        }

        //console.log("handleSearch", searchText);
        this.emit("quicksearch", searchText);
        for (let rowGroup of this.rowRegistry) {
            for (let row of rowGroup.rows) {
                if (row.node) {
                    this.UiModder.domClass.remove(row.node, "show");
                }
            }
        }

        this.UiModder.domClass.remove(this.tableRoot, "searchActive");

        if (!searchText) {
            return;
        } else {
            searchText = searchText.toLowerCase();

            this.UiModder.domClass.add(this.tableRoot, "searchActive");

            for (let rowGroup of this.rowRegistry) {
                let entity = rowGroup.entity;
                let matchedResult: boolean = false;
                for (let row of rowGroup.rows) {
                    matchedResult = false;

                    for (let cell of row.cells) {
                        // gibt es bestimmte Properties für die Suche oder kommt der Cellname vor?
                        if (!this.selectedLayout.quickSearchProperties.length ||
                            this.selectedLayout.quickSearchProperties.indexOf(cell.name) != -1) {
                            if (cell.tableCellNode.innerText.toLowerCase().indexOf(searchText) != -1) {
                                matchedResult = true;
                                break;
                            } else {

                            }
                        }
                    }

                    // noch nicht im DOM gefunden? dann die Properties vom Entity durchsuchen
                    if (!matchedResult) {
                        if (entity) {
                            for (let property in entity) {
                                if (!this.selectedLayout.quickSearchProperties.length ||
                                    this.selectedLayout.quickSearchProperties.indexOf(property) != -1) {
                                    let value: any = entity[property];
                                    if (typeof (value) == "string") {

                                    } else if (typeof (value) == "number") {
                                        value = value.toString();
                                    } else {
                                        try {
                                            value = value.toString();
                                        } catch (ex) {

                                        }
                                    }

                                    if (value && value.toLowerCase().indexOf(searchText) != -1) {
                                        matchedResult = true;
                                    }
                                }

                            }
                        }
                    }

                    if (matchedResult === true) {
                        this.UiModder.domClass.add(row.node, "show");
                    }
                }
            }
        }
    }

    private _onGlobalClick(evt: MouseEvent): void {
        this.closeAllOverflowContents();
        this._onCloseContextMenu();
    }

    private closeAllOverflowContents(): void {
        let dropdowns: HTMLCollectionOf<Element> = document.getElementsByClassName("table_dropdown_content");
        for (let y = 0; y < dropdowns.length; y++) {
            let element = dropdowns[y];
            this.UiModder.domConstruct.destroy(element);
        }

        let overflowContainer: HTMLCollectionOf<Element> = document.getElementsByClassName("overflowContainer table_dropdown clicked");
        for (let y = 0; y < overflowContainer.length; y++) {
            let element = overflowContainer[y];
            this.UiModder.domClass.remove(element, "clicked");
        }
    }

    private _initRowSortingAttributes() {
        if (this.rowSortingAttr && this.data) {

            for (let i = 0; i < this.data.length; i++) {
                let entry = this.data[i];
                let currentEntryNumber = i + this.indexOffset;
                if (typeof (entry[this.rowSortingAttr]) == "undefined") {
                    entry[this.rowSortingAttr] = currentEntryNumber;
                } else if (typeof (entry[this.rowSortingAttr]) != "number") {
                    console.warn(this.id + ": Property '" + this.rowSortingAttr + "' already declared on object, but is not yet a number. It will be used for row sorting and is being overwritten.", entry, entry[this.rowSortingAttr]);
                    entry[this.rowSortingAttr] = currentEntryNumber;
                }
            }

            this.sortData();
        }
    }
    /**
     * ENTWICKLUNG!
     */
    addEntity(data: any, targetIndex: number | "first" | "last") {
        if (!this.data) {
            this.data = [];
        }

        if (targetIndex == "first") targetIndex = 0;
        if (typeof targetIndex == 'number') {
            if (targetIndex < 0) targetIndex = 0;
        }

        if (targetIndex == "last" || targetIndex >= this.data.length) {
            this.data.push(data);
            targetIndex = this.data.length - 1;
        }
        else {
            this.data.splice(targetIndex, 0, data);
        }

        this.updateEntity(data, targetIndex);
    }
    /**
     * @param callback Callback beim Aufruf der Aktion. Dem aufgerufenen Callback wird die StaticTable.StaticTableRowGroup übergeben.
     * @param enableCallback Anhand dieses Callbacks wird dynamisch ermittelt, ob die Aktion verfügbar sein soll. Dem Callback werden entity und rowgroup übergeben.
     */
    addDefaultRowActionButton(type: StaticTable.DefaultActionSet, callback?: (rowGroup: StaticTable.StaticTableRowGroup<T>) => any, enableCallback?: (entity: T, rowGroup: StaticTable.StaticTableRowGroup<T>) => boolean, hideIfDisabled?: boolean) {
        this.addCustomRowActionButton(type, callback, null, null, null, null, enableCallback, hideIfDisabled);
    }
    private _checkActionButtonEnablingState(actionname: string, rowGroup: StaticTable.StaticTableRowGroup<any>, forceState?: boolean) {
        if (!rowGroup) return;

        let entry = rowGroup.actions[actionname];

        if (entry) {

            let enable = true;

            let reg = this.actionRegistry[actionname];
            if (reg) {


                if (reg.enableCallback && forceState !== true) {
                    enable = reg.enableCallback(rowGroup.entity, rowGroup);
                } else {
                    enable = reg.enabled;
                }

                //let hide = (reg.use != true && reg.hidden == true && enable != true;
                //let show = (reg.hidden != true || enable == true) && reg.use == true;


                let hide = (reg.hideIfDisabled == true && enable != true) || reg.use != true;
                //reg.hidden = hide;

                this.hideNode(entry.node, hide);
                this.disableNode(entry.node, enable !== true);

                return;

            }
        }


    }


    /**
     * Das Entity kann null sein, dann werden für alle Tabellenzeilen die Actions enabled oder disabled.
     * Wenn das enable-Flag nicht mitgegeben wird, erfolgt die Neuberechnung anhand der Registrierung des Buttons (dynamisch mit Callback, falls hinterlegt)
     * @param enable Übersteuert die Verfügbarkeit des Buttons. Der Button wird ansonsten anhand seiner Registrierung via Callback prüfen, ob er anklickbar ist.
     * @param show Übersteuert die Anzeige des Buttons. Der Button wird ansonsten anhand seiner Registrierung versteckt, wenn er disabled ist. 'current' belässt den Button in seinem aktuellen Zustand, auch wenn er als hideIfDisabled regstriert ist.
     */
    enableActionButton(actionname: string, entity?: any, enable?: boolean | StaticTable.actionEnableCallback, show?: boolean | "current") {


        if (!entity || !this.rowRegistry?.length) {
            // kein Entity? dann allgemeingültig umschalten und in der Registry vormerken für zukünftiges Neuzeichnen
            for (let key in this.actionRegistry) {
                let reg = this.actionRegistry[key];
                if (reg.actionname == actionname) {
                    if (enable === true || enable == false) {
                        reg.enabled = enable === true;
                        reg.enableCallback = null;
                    } else if (typeof (enable) == "function") {
                        reg.enableCallback = enable;
                    }
                    if (show !== true && show !== false) {
                        show = reg.hideIfDisabled !== true || enable == true;
                    }

                    //reg.hidden = !show;


                    // für jede Reihe anwenden:
                    for (let rowgroup of this.rowRegistry) {

                        if (rowgroup.actions.length) {
                            let rowgroupAction = rowgroup.actions[actionname];
                            if (rowgroupAction) rowgroupAction.reg = reg;
                        }
                        this._checkActionButtonEnablingState(actionname, rowgroup, enable === true || enable == false ? enable : null)
                    }
                    break;
                }
            }

            return;
        }

        // wenn Entity: Row mit Entity suchen
        let rowGroup = this.getRowGroupByKeyValue(entity[this.keyAttribute]);

        if (!rowGroup) return;

        let entry = rowGroup.actions[actionname];

        if (entry) {

            if (enable === true || enable === false) {
                this.disableNode(entry.node, enable !== true);

                if (show !== true && show !== false && show != "current") {
                    entry.reg.enabled = enable;

                    if (entry.reg.hideIfDisabled == true) {
                        this.hideNode(entry.node, enable !== true);
                    }
                }

            } else if (typeof (enable) == "function") {
                entry.reg.enableCallback = enable;
                this._checkActionButtonEnablingState(actionname, rowGroup);
            } else {
                this._checkActionButtonEnablingState(actionname, rowGroup);
            }

            if (show === true || show === false) {
                this.hideNode(entry.node, show === false);
            } else {

            }

        }

    }
    /**
     * Fügt einen Aktionsbutton in die Aktionsspalte hinzu. Dem aufgerufenen Callback wird die StaticTable.StaticTableRowGroup übergeben.
     * @param enable Entweder ein statischer Vorgabewert oder eine Funktion (Entitydata wird übergeben, boolean wird erwartet), die dynamisch pro Entity prüft
     * @param position Fügt den Button an einer Stelle vor, zwischen oder nach anderen Buttons ein. Standardbuttons befinden sich von 100-110, 200/201 (sorting) sowie 99998 aufwärts (delete und select)
     */
    addCustomRowActionButton(name: string,
        callback: (rowGroup: StaticTable.StaticTableRowGroup<T>) => any,
        iconClass?: string,
        buttonLabel?: string,
        position?: number,
        title?: string,
        enable?: boolean | ((entity: T, rowGroup: StaticTable.StaticTableRowGroup<T>) => boolean),
        hideIfDisabled?: boolean) {
        this.addCustomRowActionButtonEx({
            name: name,
            callback: callback,
            iconClass: iconClass,
            position: position,
            tooltipTitle: title,
            enable: enable,
            hideIfDisabled: hideIfDisabled,
            buttonLabel: buttonLabel
        })
    }

    addCustomRowActionButtonEx(config: {
        name: string,
        callback: (rowGroup: StaticTable.StaticTableRowGroup<T>) => any,
        iconClass?: string,
        buttonLabel?: string,
        position?: number,
        tooltipTitle?: string,
        enable?: boolean | ((entity: T, rowGroup: StaticTable.StaticTableRowGroup<T>) => boolean),
        hideIfDisabled?: boolean
    }) {

        if (config.hideIfDisabled !== false && config.hideIfDisabled !== true) config.hideIfDisabled = true;

        let entry = this.actionRegistry[config.name];
        if (entry) {
            entry.callback = config.callback ? config.callback : null;
            entry.enableCallback = typeof (config.enable) == "function" ? config.enable : null,
                entry.iconClass = config.iconClass ? config.iconClass : entry.iconClass;
            entry.use = true;
            //entry.hidden = hideIfDisabled === true;
            entry.hideIfDisabled = config.hideIfDisabled === true;
            return;
        }

        switch (config.name) {
            case "rowsorting":
                this.setupRowSorting("order", config.callback, config.enable);
                break;
            default:
                this.actionRegistry[config.name] = {
                    actionname: config.name as any,
                    callback: config.callback ? config.callback : null,//callback,
                    iconClass: config.iconClass,
                    use: true,
                    buttonLabel: config.buttonLabel,
                    //hidden: hideIfDisabled === true,
                    hideIfDisabled: config.hideIfDisabled === true,
                    enabled: config.enable === true || config.enable === false ? config.enable : true,
                    enableCallback: typeof (config.enable) == "function" ? config.enable : null,
                    position: typeof (config.position) == "number" ? config.position : Object.keys(this.actionRegistry).length,
                    title: config.tooltipTitle ? TranslationHelpers.tryTranslate(config.tooltipTitle) : null
                };
                break;
        }
    }

    /**
     * native Buttons zum Sortieren von Tabelleneinträgen hinzufügen.
     * @param sortingAttributeName Dieses Property wird zur Sortierung der Einträge herangezogen. Das Property wird erstellt, falls nicht auf den Einträgen vorhanden.
     * @param callback Callback, das nach dem Verschieben aufgerufen wird. Übergeben werden die beiden Rowgroups, die durch die Sortierung beeinflusst worden sind.
     */
    setupRowSorting(sortingAttributeName: string, callback?: (rowGroup: StaticTable.StaticTableRowGroup<T>) => any, enable?: boolean | ((entity: T, rowGroup: StaticTable.StaticTableRowGroup<T>) => boolean)) {
        if (sortingAttributeName) {
            this.rowSortingAttr = sortingAttributeName;
            this.setGroupingEnabled(false);

            if (this.data) {
                this._initRowSortingAttributes();
            }

            this.addCustomRowActionButton("moveup", callback, null, null, null, null, enable);
            this.addCustomRowActionButton("movedown", callback, null, null, null, null, enable);
        }
    }

    enableRowSelection(enable?: boolean) {
        if (enable !== false) enable = true;

        this.addDefaultRowActionButton("select");
    }

    private _defaultExpanderConfig: StaticTable.ExpanderConfig;
    //private _defaultRowExpanderClickCallback: StaticTable.expanderclickCallback;
    //private _defaultRowExpanderSetupCallback: StaticTable.expanderSetupCallback;

    /**
     * Ein Expander-Setup durchführen: Für jede erstmals neu gezeichnet Rowgroup wird ein Callback ausgelöst, das als Returnvalue ein HTML-Element liefert.
     * Dieses wird als Expander-Content zur Datenzeile hinterlegt.
     * Optional wird expanderClickCallback als Standard hinterlegt und aufgerufen, wenn eine Zeile aufgeklappt wird.
     * @param expanderSetupCallback
     */
    setupExpandableRows(config: StaticTable.ExpanderConfig) {

        if (!config) {
            for (let rowgrp of this.rowRegistry) {
                if (rowgrp.expanderRow) this.setRowGroupExpanderContent(rowgrp.entity, null, null);
            }
        }
        else if (typeof (config.expanderContentCallback) == "function") {
            this._defaultExpanderConfig = config;
            //this._defaultRowExpanderSetupCallback = config.expanderSetupCallback;

            //if (config.expanderClickCallback || config.expanderClickCallback == null) this._defaultRowExpanderClickCallback = config.expanderClickCallback;
        }

    }

    isRowExpanded(rowIndexOrEntity: number | Object): boolean {
        let targetGroup: StaticTable.StaticTableRowGroup<any> = null;

        if (typeof (rowIndexOrEntity) == "number") {
            targetGroup = this.rowRegistry[rowIndexOrEntity];
        } else if (typeof (rowIndexOrEntity) == "object" && !!rowIndexOrEntity) {
            targetGroup = this.getRowGroupByKeyValue(rowIndexOrEntity[this.keyAttribute])
        }

        if (!targetGroup) return false;
        let existingReg = this.expanderRegistry[targetGroup.keyValue];

        if (existingReg && existingReg.rowNode) {
            return existingReg.currentExpandState === true;
        }

        return false;
    }

    expandRow(rowIndexOrEntity: number | Object, expand: boolean = true) {
        let targetGroup: StaticTable.StaticTableRowGroup<any> = null;
        if (typeof (rowIndexOrEntity) == "number") {
            targetGroup = this.rowRegistry[rowIndexOrEntity];
        } else if (typeof (rowIndexOrEntity) == "object" && !!rowIndexOrEntity) {
            targetGroup = this.getRowGroupByKeyValue(rowIndexOrEntity[this.keyAttribute])
        }

        let existingReg = this.expanderRegistry[targetGroup.keyValue];

        if (existingReg && existingReg.rowNode) {
            if (expand !== false) expand = true;
            if (existingReg.currentExpandState == expand) return;

            this.UiModder.domClass.toggleMultiple(targetGroup.rows.map(row => row.node), "expanded", expand === true);
            this.UiModder.domClass.toggleMultiple(targetGroup.rows.map(row => row.node), "collapsed", expand !== true);

            if (existingReg.currentExpandState != expand) {
                //this.hideNode(existingReg.rowNode, expand !== true);
                this.UiModder.domClass.add(existingReg.rowNode, "animate");

                setTimeout(lang.hitch(this, function () {
                    this.UiModder.domClass.toggle(existingReg.rowNode, "expanded", expand === true);
                    this.UiModder.domClass.toggle(existingReg.rowNode, "collapsed", expand !== true);
                }), 5);

                setTimeout(lang.hitch(this, function () {
                    this.UiModder.domClass.remove(existingReg.rowNode, "animate");

                }), 300);


                existingReg.currentExpandState = expand === true;

                if (typeof (existingReg.expandclickCallback) == "function") {
                    existingReg.expandclickCallback(expand === true, existingReg.containerNode, targetGroup);

                }
            }
        }
    }

    /**
     * Erweitert eine Tabellenreihe so, dass sie "aufklappbar" wird. Der übergebene content wird in eine Tabellenzeile mit voller Breite eingebettet. Optional wird bei jedem Toggle das Callback aufgerufen (zB. zur Aktualisierung des Inhalts)
     * @param rowIndexOrEntity
     * @param contentElement
     * @param expandCallback
     */
    setRowGroupExpanderContent(rowIndexOrEntity: number | T, contentElement: HTMLElement, expand?: boolean, expandCallback?: StaticTable.expanderclickCallback) {

        // HIER TODO
        // wie wir die Node ausgetauscht? Statictable muss hier entweder die Containernode retour geben, oder die Funtion bekommt ein htmlElement als Parameter
        let targetGroup: StaticTable.StaticTableRowGroup<T> = null;
        if (typeof (rowIndexOrEntity) == "number") {
            targetGroup = this.rowRegistry[rowIndexOrEntity];
        } else if (typeof (rowIndexOrEntity) == "object" && !!rowIndexOrEntity) {
            targetGroup = this.getRowGroupByKeyValue(rowIndexOrEntity[this.keyAttribute])
        }



        if (!targetGroup) return;

        let keyValue: string = targetGroup.keyValue;

        if (!contentElement) {
            if (targetGroup.expanderRow) {
                for (let row of targetGroup.rows) {
                    this.UiModder.domClass.remove(row.node, "expandable collapsed expanded");
                }

                this.UiModder.domConstruct.destroy(targetGroup.expanderRow);
            }

            targetGroup.expanderRow = null;

            this.expanderRegistry[keyValue] = null;

            return;
        } else {
            for (let row of targetGroup.rows) {
                this.UiModder.domClass.add(row.node, "expandable collapsed");
            }

            let existingReg = this.expanderRegistry[keyValue];

            if (existingReg && existingReg.rowNode) {
                this.UiModder.domConstruct.place(existingReg.rowNode, targetGroup.rows[targetGroup.rows.length - 1].node, "after");
                existingReg.rowGroup = targetGroup;
                this.expandRow(targetGroup.rowIndex, existingReg.currentExpandState);
            } else {
                let expRow = this.UiModder.domConstruct.create("tr", {
                    className: "expanderRow collapsed",
                    "data-tr_parentIndex": targetGroup.rowIndex.toString(),

                }, targetGroup.rows[targetGroup.rows.length - 1].node, "after") as HTMLTableRowElement;




                let emptyCell = this.UiModder.domConstruct.create("td", {
                    className: "spacer",
                    colSpan: this.showIndexColumn ? "2" : "1"
                }, expRow);

                let expCell = this.UiModder.domConstruct.create("td", {
                    className: "expanderCell",
                    colspan: this.maxColspan.toString()
                }, expRow);

                on(expCell, "mouseenter", lang.hitch(this, this._onMouseEnter_ExpanderRow, keyValue));
                on(expCell, "mouseleave", lang.hitch(this, this._onMouseLeave_ExpanderRow, keyValue));



                let expanderContainer = this.UiModder.domConstruct.create("div", {
                    className: "expanderRowContainer"
                }, expCell);
                /** der collapsingcontainer wird für die expander-Animation benötigt mit Grid-Style*/
                let collapsingContainer = this.UiModder.domConstruct.create("div", {
                    className: "collapsingContainer"
                }, expanderContainer);

                //let displayname = this.getEntityDisplayName(targetGroup.entity[this.keyAttribute]);
                //if (displayname) {
                //    this.UiModder.domConstruct.create("h6", {
                //        className: "expanderContentDisplayname",
                //        innerHTML: displayname
                //    }, collapsingContainer);
                //}

                let innerContainer = this.UiModder.domConstruct.create("div", {
                    className: "innerContainer"
                }, collapsingContainer);

                targetGroup.expanderRow = expRow;
                this.UiModder.domConstruct.place(contentElement, innerContainer, "only");

                this.expanderRegistry[keyValue] = {
                    currentExpandState: expand === true,
                    containerNode: innerContainer,
                    expandclickCallback: expandCallback,
                    rowNode: expRow,
                    cellNode: expCell,
                    rowGroup: targetGroup,
                    isSetup: true
                };
            }

        }
    }

    private _onClickExpandRowGroup(rowgrp: StaticTable.StaticTableRowGroup<any>, evt: MouseEvent) {

        if (!rowgrp) return;

        let expanderReg = this.expanderRegistry[rowgrp.keyValue];

        if (!expanderReg) return;

        if (evt?.stopPropagation) evt.stopPropagation();
        this.expandRow(rowgrp.rowIndex, !expanderReg.currentExpandState);
    }

    private _domnodeObserver: MutationObserver;
    private _onDomnodeObserver(mutationList, observer) {
        //console.debug(this.id + " _onDomnodeObserver", mutationList, observer, this.domNode);

        if (this.domNode?.parentNode) {
            this._disconnectObserver();
            this._checkCellOverflow();
        } else {
            setTimeout(lang.hitch(this, this._disconnectObserver), 5000);
        }
    }

    private _disconnectObserver() {
        try {
            if (this._domnodeObserver) {
                this._domnodeObserver.disconnect();
                this._domnodeObserver = null;

            }
        } catch (ex) {

        }
    }

    destroy() {
        this._disconnectObserver();
        try {
            this.layoutSelectButton.destroy();
        } catch (ex) {

        }

        let self: any = this;
        let result = super.destroy.apply(this, arguments as any);
    }

    private _afterPlace() {

        if (this._domnodeObserver) {
            this._domnodeObserver.disconnect();
            this._domnodeObserver = null;
            this._checkCellOverflow();
        }
    }

    postCreate(): void {
        let self: any = this;
        super.postCreate.apply(this, arguments as any);
        this.addSubscription("/Global/Click", lang.hitch(this, this._onGlobalClick));

        this.actionRegistry = {};

        if (this.domNode.isConnected != true) {

            aspect.after(this, "placeAt", lang.hitch(this, this._afterPlace));

            this._domnodeObserver = new MutationObserver(lang.hitch(this, this._onDomnodeObserver));
            this._domnodeObserver.observe(document.body, {
                childList: true,
                //attributeFilter:["isConnected"]
            });
        }

        this.actionRegistry["moveup"] = {
            actionname: "moveup",
            callback: null,
            use: false,
            enabled: true,
            title: TranslationHelpers.translate("General_Label_Sorting_MoveUp", true),
            //hidden: false,
            hideIfDisabled: false,
            iconClass: "fas fa-chevron-circle-up",
            position: 200
        };
        this.actionRegistry["movedown"] = {
            actionname: "movedown",
            callback: null,
            use: false,
            enabled: true,
            title: TranslationHelpers.translate("General_Label_Sorting_MoveDown", true),
            // hidden: false,
            hideIfDisabled: false,
            iconClass: "fas fa-chevron-circle-down",
            position: 201
        };
        this.actionRegistry["view"] = {
            actionname: "view",
            callback: null,
            use: false,
            enabled: true,
            title: TranslationHelpers.translate("General_Label_ShowView", true),
            //hidden: false,
            hideIfDisabled: false,
            iconClass: "fas fa-eye",
            position: 100,
        };
        this.actionRegistry["sync"] = {
            actionname: "sync",
            callback: null,
            use: false,
            enabled: true,
            title: "General_Label_Update",
            // hidden: false,
            hideIfDisabled: false,
            iconClass: "fas fa-sync",
            position: 115,
        };

        this.actionRegistry["edit"] = {
            actionname: "edit",
            callback: null,
            use: false,
            enabled: true,
            title: TranslationHelpers.translate("General_Edit", true),
           // hidden: false,
            hideIfDisabled: false,
            iconClass: "fas fa-edit",
            position: 110,
        };
        this.actionRegistry["select"] = {
            actionname: "select",
            callback: null,
            use: false,
            enabled: true,
           // hidden: false,
            hideIfDisabled: false,
            iconClass: "far fa-circle",
            position: 99999,
        };
        this.actionRegistry["delete"] = {
            actionname: "delete",
            callback: null,
            use: false,
            enabled: true,
            title: TranslationHelpers.translate("General_Delete", true),
            // hidden: false,
            hideIfDisabled: false,
            iconClass: "fas fa-trash warningTXT",
            position: 99998
        };

        this.rowConfigs = [];
        this.rowRegistry = [];
        this.availableLayouts = [];

        this.tableHeads = [];

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.inputQuicksearch.domNode, "inputQuicksearch", this.inputQuicksearchLabel);
        AccessibilityLabelsHelper.InputLabelledbyBind([
            {
                labelElement: this.labelNode, labelIdValue: "staticTableLabel"
            }],
            this.tableRoot,
            this.id);
    }

    startup(): void {
        // required for dojo inheritance to call the superclass
        let self: any = this;
        super.startup.apply(this, arguments as any);

        this.PitHelper._structureFormat = "json";

        if (this.data && this.selectedLayout && !this.tableRoot) {
            if (this.groupingProperty || this.rowSortingAttr) {
                this.sortData();
            }

            this.drawTable();
        }
    }

    setCyAttribute(value: string): void {
        if (value && this.tableRoot) {
            this.tableRoot.setAttribute("data-cy", value);
            this.tableRoot.setAttribute("data-e2e-role", "table");
        }

    }

    public setAllDataCyAttributes() {
        this.setDataCyAttribute(this.tableRoot, "");
        this.tableRoot.setAttribute("data-e2e-role", "table");
    }
}

export default mdsWidget(StaticTable);
